import { CONSTANTS, PAGE_BUILDER_ENDPOINTS, RENDERING_ENDPOINTS, DATA_MAPPING_TRAIT, DATA_MAPPING_TRAIT_WITH_SOCIAL, SOCIAL_DATA_MAPPING_TRAIT } from "./constants";
import BreakingNewsIcon from "../images/custom-icons/breaking_news.svg";
import GridViewIcon from "../images/custom-icons/grid.svg";
import GridViewIconLess from "../images/custom-icons/grid_viewless.svg";
import HeaderIcon from "../images/custom-icons/header.svg";
import FooterIcon from "../images/custom-icons/footer.svg";
import HeroLayoutIcon from "../images/custom-icons/hero_layout.svg";
import HeroLayoutSecondIcon from "../images/custom-icons/Hero_layout_new.svg";
import CarouselCardIcon from "../images/custom-icons/carousel_card.svg";
import ListViewIcon from "../images/custom-icons/list_view.svg";
import SimilarStoriesIcon from "../images/custom-icons/similar_stories.svg";
import ArticleShowIcon from "../images/custom-icons/article_show.svg";
import VideoStoriesIcon from "../images/custom-icons/video_stories.svg";
import BreadCrumbsIcon from "../images/custom-icons/bread_crumbs.svg";
import ErrorPageIcon from "../images/custom-icons/error_page.svg";
import AuthorShowIcon from "../images/custom-icons/author_show.svg";
import SlideShowIcon from "../images/custom-icons/slide_show.svg";
import StaticPageIcon from "../images/custom-icons/static_page.svg";
import AddScriptIcon from "../images/custom-icons/add_script.svg";
import WebstoriesCircle from "../images/custom-icons/webstories_circle.svg";
import WebstoriesCard from "../images/custom-icons/web_stories_card.svg";
import WebstoriesCardList from "../images/custom-icons/web_stories_card_list.svg";
import centerCarousal from "../images/custom-icons/centerCarousal.png";
import firstBigCarousel from "../images/custom-icons/firstBig_carousel.svg";
import videoReel from "../images/custom-icons/video_reel.svg";
import LandscapeCardCarousel from "../images/custom-icons/Landscape_Card_Carousel.svg";
import { getDefaultMsids, getSessionObject, toSlugify } from "./Utils";
import PollIcon from "../images/custom-icons/bar_chart.svg";
import DynamicListIcon from "../images/custom-icons/dynamic_list.svg";
import ContactTagIcon from "../images/custom-icons/content_tags.svg";
import SimilarstoriesNewIcon from "../images/custom-icons/Similarstories.svg";
import MainMenuIcon from "../images/custom-icons/main_menu.svg";
//const { defaultPriortyListMsid, defaultListingMsid, defaultArticleMsid, defaultVideoMsid, defaultSlideshowMsid, defaultAuthorID, defaultStaticMsid, defaultLiveblogMsid } = await getDefaultMsids();
/** When a theme reuses another theme's CSS, list every body class to apply (order preserved). */
const THEME_BODY_CLASS_IDS = {
	6: ['4', '6'],
};


function getBodyClass(classList, themeId) {
	const n = themeId + '';
	const ids = THEME_BODY_CLASS_IDS[n] ?? [n];
  ids.forEach(id => classList.add(`theme_${id}`));
  
}
const createComponentJson = async () => {

  return new Promise((resolve) => {

    let metaData = sessionStorage.getItem("metaData");
    let data = metaData != null ? JSON.parse(metaData) : "";
    let retrievedWebsiteId = data.websiteId;
    let retrievedClientId = data.clientId;
    let tenantId = data.tokenPayload?.tenantId;
    let componentJson = [];

    if (retrievedClientId || retrievedWebsiteId) {
      let { defaultSystemHostId, defaultKeywords, defaultPriortyListMsid, defaultListingMsid, defaultArticleMsid, defaultVideoMsid, defaultSlideshowMsid, defaultAuthorID, defaultStaticMsid, themeId, themeName, defaultQuizId, defaultSurveyId, defaultLiveblogMsid, defaultSystemTenentId, siteLanguage } = getDefaultMsids() || {};
      // let defaultQuizId = 113414846; 
      // let defaultQuizHostId = 421; 
      // let defaultSurveyId = 112466373;
      // let defaultSurveyHostId = 421;
      localStorage.setItem("themeId", themeId);
      //defaultSystemHostId = 387;
      //defaultSystemTenentId = 7;
      const retrievedHostId = sessionStorage.getItem('hostId');
      const userHostId = (retrievedHostId !== null && retrievedHostId !== undefined && retrievedHostId !== '0') ? retrievedHostId : '0';
      const defaultHostId = defaultSystemHostId;
      const defaultTenentId = defaultSystemTenentId;

      let iframes = document.getElementsByClassName("gjs-frame");
      if (iframes && iframes[0] && iframes[0].contentWindow) {
        for (let classNam of iframes[0].contentWindow.document.body.classList) {
          if (classNam.includes("theme_")) {
            iframes[0].contentWindow.document.body.classList.remove(classNam);
          }
        }
        getBodyClass(iframes[0].contentWindow.document.body.classList, themeId);

        // Apply language and direction to both the main document and the canvas iframe on load
        const isArabic = siteLanguage === 'ar';
        const langVal = siteLanguage || 'en';
        const dirVal = isArabic ? 'rtl' : 'ltr';
        document.documentElement.lang = langVal;
        document.documentElement.dir = dirVal;
        iframes[0].contentWindow.document.documentElement.lang = langVal;
        iframes[0].contentWindow.document.documentElement.dir = dirVal;
      }

      let defaultIds = [
        defaultPriortyListMsid,
        defaultListingMsid,
        defaultArticleMsid,
        defaultVideoMsid,
        defaultSlideshowMsid,
        defaultAuthorID,
        defaultStaticMsid,
        defaultQuizId,
        defaultSurveyId,
        defaultLiveblogMsid,
        defaultSystemTenentId
      ];
      localStorage.setItem("defaultIds", JSON.stringify(defaultIds));
      localStorage.setItem("defaultKeywords", defaultKeywords);
      localStorage.setItem("defaultSystemHostId", defaultSystemHostId);
      localStorage.setItem("defaultSystemTenentId", defaultSystemTenentId);
      localStorage.setItem("defaultListingMsid", defaultListingMsid);
      localStorage.setItem("defaultPriortyListMsid", defaultPriortyListMsid);
      localStorage.setItem("defaultArticleMsid", defaultArticleMsid);
      localStorage.setItem("defaultAuthorID", defaultAuthorID);
      localStorage.setItem("defaultLiveblogMsid", defaultLiveblogMsid);

      componentJson = [
        // ----------------------------theme-two-comoponents------------------------------------------------

        {
          name: "Ad Scripts Two",
          media: AddScriptIcon,
          traits: [
            // {
            //   type: 'custom-textarea',
            //   label: 'Header Script',
            //   name: 'headAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script',
            //   name: 'bodyAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script (Mobile)',
            //   name: 'bodyAdMobileScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Ad Size',
            //   name: 'adSize',
            //   changeProp: 1,
            //   value: '300*100',
            //   options: [
            //     { label: '300*100', value: "300*100" },
            //     { label: '300*250', value: "300*250" },
            //     { label: '970*90', value: "970*90" },
            //   ]
            // },
            {
              type: 'belly-ad-accodian-trait',
              label: 'Ad Script',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }
          ],
          attributes: {
            title: "Ad Scripts Two",
            name: "Ad Scripts Two",
            version: "1000",
            adSize: "300*100",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showAdSlot: true,
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            adConfigurations: {}
          }
        },

        {
          name: "Ad Scripts Two Amp",
          media: AddScriptIcon,
          traits: [
            // {
            //   type: 'custom-textarea',
            //   label: 'Header Script',
            //   name: 'headAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script',
            //   name: 'bodyAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script (Mobile)',
            //   name: 'bodyAdMobileScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Ad Size',
            //   name: 'adSize',
            //   changeProp: 1,
            //   value: '300*100',
            //   options: [
            //     { label: '300*100', value: "300*100" },
            //     { label: '300*250', value: "300*250" },
            //     { label: '970*90', value: "970*90" },
            //   ]
            // },
            {
              type: 'belly-ad-accodian-trait',
              label: 'Ad Script',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }
          ],
          attributes: {
            title: "Ad Scripts Two Amp",
            name: "Ad Scripts Two Amp",
            version: "1000",
            adSize: "300*100",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showAdSlot: true,
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            adConfigurations: {}
          }
        },


        {
          name: "Article Show Two",
          // scriptProps: [
          //   'imagecroptype' // The crucial addition for dropdown
          // ],
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Synopsis Abov Img',
              name: 'SynopsisAbovImg',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              options: [
                { id: 7, name: 'True', value: true },
                { id: 8, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 9, name: 'True', value: true },
                { id: 19, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Caption',
              name: 'showImageCaption',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Related Stories',
              name: 'showRelatedStories',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                 //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            SynopsisAbovImg:false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showRelatedStories: false,
            relatedStoriesLable: 'More stories on',

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            authorCard: false,
            imagecroptype: '4',
            isImageTitle: true,
            showImageCaption: false,

            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultArticleMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Article Show Four",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },

            {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                { label: 'Central Cropping', value: '4' },
                { label: 'White Border', value: '71' },
                { label: 'Black Border', value: '72' },
                { label: 'Most Prominent Color', value: '73' },
                { label: 'Most Prominent Color (single)', value: '74' },
                { label: 'Blurred Background', value: '75' },
                { label: 'Face-Aware Cropping', value: '8' },
              ],
              value: '4'
            },
            {
              type: 'custom-select',
              label: 'Article Body Image Resize Type',
              name: 'articlebodyimagecroptype',
              changeProp: 1,
              options: [
                { label: 'Central Cropping', value: '4' },
                { label: 'White Border', value: '71' },
                { label: 'Black Border', value: '72' },
                { label: 'Most Prominent Color', value: '73' },
                { label: 'Most Prominent Color (single)', value: '74' },
                { label: 'Blurred Background', value: '75' },
                { label: 'Face-Aware Cropping', value: '8' },
              ],
              value: '4'
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
                        {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Related Stories',
              name: 'showRelatedStories',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Title',
              name: 'hideTitle',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Lead Image',
              name: 'hideLeadImage',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Synopsis',
              name: 'showSynopsis',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            name: "Article Show Four",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            version: "1000",
            authorCard: true,
            showAuthor: true,
            showDateTime: true,
            isImageTitle: false,
            showNewsAgency: true,
            showImageCredits: true,
            showTags: false,
            showRelatedStories: false,
            relatedStoriesLable: 'More stories on',
            adConfigurations: {},
            enableCharCount: false,
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            showAdSlot: false,
            hideTitle: true,
            hideLeadImage: true,
            showSynopsis: true,
            imagecroptype: '4',
            articlebodyimagecroptype: '4',
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [{
              name: "MAIN",
              LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
              STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
              primary: true,
              isSSR: true,
              preview: false,
              SSRDataObj: null,
              isNotListing: true,
              queryParams: {
                msid: defaultArticleMsid,
                hostId: defaultHostId,
                fv: 1000,
                links: 1,
                count: 1,
                cloneMapping: [
                  { from: "defaultArticleMsid", to: "msid" },
                  { from: "defaultHostId", to: "hostId" }
                ]
              }
            }]
          }
        },

        {
          name: "Immersive Story",
          media: ArticleShowIcon,
          traits: [],
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Immersive Story",
            // Filled by setCmsSeoData at render time; the rendering engine reads it for
            // the page's title, description and canonical (same contract as Article Show).
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            version: "1000",
            imageDomain: "http://staticimg.publishstory.co",
            ENV: CONSTANTS.ENV.M360_STAGING,
            // Immersive Story is an article-detail component, so msid comes from the URL
            // at runtime (pathquery) — same contract as Article/Video/Slide Show.
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  // msid: defaultArticleMsid,
                  // hostId: defaultHostId,

                  msid: "123766284",
                  hostId: "83",

                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Lead Image Article Show",
          traits: [
            // {
            //   type: 'custom-select',
            //   label: 'Position of heading',
            //   name: 'headingPosition',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Over image', value: 'over' },
            //     { label: 'Below image', value: 'below' },
            //     { label: 'Above image', value: 'above' },
            //   ],
            //   value: 'over',
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Initial view (SSR)',
            //   name: 'initialView',
            //   changeProp: 1,
            //   options: [
            //     { label: 'With title in view', value: 'withtitleinview' },
            //     { label: 'Leaderboard in view', value: 'leaderboardinview' },
            //     { label: 'Full image', value: 'fullimage' },
            //     { label: 'None', value: 'none' },
            //   ],
            //   value: 'withtitleinview',
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Click to show image till',
            //   name: 'clickToshowImagetil',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Full image', value: 'full' },
            //     { label: 'Leaderboard', value: 'leaderboard' },
            //     { label: 'Title', value: 'title' },
            //     { label: 'None (no arrow)', value: 'none' },
            //   ],
            //   value: 'title',
            // },
            {
              type: 'custom-toggle',
              label: 'Hide Title',
              name: 'hideTitle',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Hide Lead Image',
            //   name: 'hideLeadImage',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     return !this.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Show Lead Image Caption',
              name: 'showLeadImageCaption',
              changeProp: 1,
              isNotChecked: function () {
                return !this.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Show Synopsis',
            //   name: 'showSynopsis',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     return !this.value;
            //   }
            // },
            {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                { label: 'Central Cropping', value: '4' },
                { label: 'White Border', value: '71' },
                { label: 'Black Border', value: '72' },
                { label: 'Most Prominent Color', value: '73' },
                { label: 'Most Prominent Color (single)', value: '74' },
                { label: 'Blurred Background', value: '75' },
                { label: 'Face-Aware Cropping', value: '8' },
              ],
              value: '4'
            },
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            name: "Lead Image Article Show",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            version: "1000",
            headingPosition: 'over',
            initialView: 'withtitleinview',
            clickToshowImagetil: 'title',
            hideTitle: false,
            hideLeadImage: false,
            showLeadImageCaption: true,
            showSynopsis: true,
            imagecroptype: '4',
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [{
              name: "MAIN",
              LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
              STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
              primary: true,
              isSSR: true,
              preview: false,
              SSRDataObj: null,
              isNotListing: true,
              queryParams: {
                msid: defaultArticleMsid,
                hostId: defaultHostId,
                fv: 1000,
                links: 1,
                count: 1,
                cloneMapping: [
                  { from: "defaultArticleMsid", to: "msid" },
                  { from: "defaultHostId", to: "hostId" }
                ]
              }
            }]
          }
        },

        {
          name: "Author Show Two",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Department',
              name: 'showDepartment',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcon',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: AuthorShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Author Show Two",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showSocialIcon: true,
            showDepartment: true,
            background: '#fff',
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.AUTHOR_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.AUTHOR_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultAuthorID,
                  fv: 1000,
                  hostId: defaultHostId,
                  cloneMapping: [
                    { from: "defaultAuthorID", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "BreadCrumbs Two",
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "BreadCrumbs",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            seperator: ">>",
            categoryName: "",
            TextColor: "#000",
            includeTitle: true,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          media: BreadCrumbsIcon,
          traits: [
            {
              type: 'custom-select',
              label: 'Seperator',
              name: 'seperator',
              changeProp: 1,
              options: [
                { label: '>>', value: ">>" },
                { label: '>', value: ">" },
                { label: '/', value: "/" }
              ],
              value: ">>"
            },
            {
              type: 'text',
              name: 'categoryName',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Include Title',
              name: 'includeTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },
        {
          name: "Breaking News Ticker",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Heading BG Color",
              name: 'HeadingBGColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Heading Text Color",
              name: 'HeadingTextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'BGColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            }
          ],
          media: BreakingNewsIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: false,
            CONSTANTS: CONSTANTS,
            name: "Breaking News Ticker",
            title: "Breaking News Ticker",
            mainHeading: "Breaking News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            HeadingBGColor: "#0A66C2",
            HeadingTextColor: "#fff",
            TextColor: "#fff",
            BgColor: "#000000",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_TICKER_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_TICKER_API,
                isSSR: false,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  tenantId: tenantId,
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Footer Two",
          traits: [
            {
              type: 'color',
              label: "BG Color",
              name: 'BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'About Site',
              name: 'showAbout',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcons',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Footer Black Strip',
              name: 'showBlackStrip',
              changeProp: 1,
              showAbout:false,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'copyRightText',
              name: 'showSocialIcons',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Static Pages',
              name: 'showStaticPages',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            }
          ],
          media: FooterIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            BgColor: '#fff',
            TextColor: '#000',
            showAbout: true,
            showSocialIcons: true,
            showBlackStrip:true,
            copyRightText: "",
            footerLogo: "",
            title: "Footer",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            noOfHeaderItems: 10,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "FOOTER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.FOOTER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.FOOTER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "GridView Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "Background Color",
            //   name: 'BgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card BG Color",
            //   name: 'cardBGColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Scroll Mode',
            //   name: 'scroll',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Automatic', value: "automatic" },
            //     { label: 'Manual', value: "manual" },
            //   ]
            // },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            // {
            //   type: 'text',
            //   label: 'Items per-page',
            //   name: 'itemsPerPage',
            //   changeProp: 1,
            //   value: '12'
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIconLess,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "GridView Two",
            title: "Grid View",
            mainHeading: "Grid View",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            BgColor: "#ffffff",
            cardBGColor: "#ffffff",
            cardTextColor: "#555555",
            scroll: "automatic",
            showDate: true,
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            // itemsPerPage: "12",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 12,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Header Two",
          media: HeaderIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            logoUrl: "https://www.newsclick.in/sites/default/files/2022-11/narendra%20%20modi.jpg",
            isSticky: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            mainHeadingColor: "#000",
            L1BgColor: "#ffffff",
            L2BgColor: "#f1f1f1",
            L1TextColor: "#555555",
            L2TextColor: "#555555",
            HamburgerBgColor: "#ffffff",
            HamburgerTextColor: "#555555",
            HamburgerIconColor: "#555555",
            SearchIconColor: "#555555",
            topNavBarTextColor:'#666',
            topNavBarBgColor:'#F1F1F1',
            topNavigationBar:[],
            showtopbavbarheader:false,
            // SearchIconColor: "#555555",
            noOfHeaderItems: 6,
            groupMenuItems: "More",
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [

              {
              type: 'custom-toggle',
              label: 'Show Top Nav',
              name: 'showtopbavbarheader',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'color',
              label: "Top Nav Bg Color",
              name: 'topNavBarBgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Top Nav Text Color",
              name: 'topNavBarTextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L1 BG Color",
              name: 'L1BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L1 Text Color",
              name: 'L1TextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L2 BG Color",
              name: 'L2BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L2 Text Color",
              name: 'L2TextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Hamburger BG Color",
              name: 'HamburgerBgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Hamburger Text Color",
              name: 'HamburgerTextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Hamburger Icon Color",
              name: 'HamburgerIconColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Search Icon Color",
              name: 'SearchIconColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-toggle',
              label: 'Sticky Header',
              name: 'isSticky',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            },
            {
              type: 'text',
              label: 'Group Menu Item',
              name: 'groupMenuItems',
              changeProp: 1
            },
          ]
        },
        {
          name: "HeroLayout Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'BgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Publish Date',
              name: 'showPublishDate',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDate',
            //   changeProp: 1,
            //   showDate:true,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Hero layout Two",
            title: "Hero layout Two",
            mainHeading: "Hero layout Two",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            cardTextColor: "#000",
            BgColor: "#f1f1f1",
            showPublishDate: true,
            showDate: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype:'8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
                {
          name: "HeroLayout Inverted",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "HeroLayout Inverted",
            title: "HeroLayout Inverted",
            mainHeading: "HeroLayout Inverted",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            cardTextColor: "#000",
            BgColor: "#f1f1f1",
            showAuthor: true,
            showDate: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype: '8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "HeroLayout Hr Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
                        {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'BgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
                        {
              type: 'custom-toggle',
              label: 'Show Heading',
              name: 'showmainHeading',
              changeProp: 1,
              showmainHeading: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDate',
            //   changeProp: 1,
            //   showDate:true,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
              {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutSecondIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Hero layout Hr Two",
            title: "Hero layout Hr Two",
            mainHeading: "Heading",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            // cardBGColor: "pink",
            cardBGColor: "transparent",
            cardActiveColor: "#ffffff",
            showAuthor: true,
            showDate: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype:'8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Home Grid View Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'BgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card BG Color",
            //   name: 'cardBgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Scroll Mode',
            //   name: 'scroll',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Automatic', value: "automatic" },
            //     { label: 'Manual', value: "manual" },
            //   ]
            // },
            // {
            //   type: 'text',
            //   label: 'Scroll Count',
            //   name: 'scrollCount',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Top News",
            title: "Top News",
            mainHeading: "Top News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            BgColor: "#ffffff",
            cardBGColor: "#ffffff",
            cardTextColor: "#000",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthor: true,
            showDate: true,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype:'8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 9,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Quick View Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'cardBGColor',
            //   changeProp: 1
            // },

            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: LandscapeCardCarousel,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Quick View",
            title: "Quick View",
            mainHeading: "Quick View",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardBGColor: "#fff",
            cardActiveColor: "#fff",
            showDateField: true,
            showAuthorField: true,
            showDate: true,
            showAuthor: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            imagecroptype:'8',
            bodyAdMobileScript: "",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "List View Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '10'
            },
            // {
            //   type: 'color',
            //   label: "Card Color",
            //   name: 'cardColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'cardBgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Scroll Mode',
            //   name: 'scroll',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Automatic', value: "automatic" },
            //     { label: 'Manual', value: "manual" },
            //   ]
            // },
            // {
            //   type: 'text',
            //   label: 'Scroll Count',
            //   name: 'scrollCount',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
             {
              type: 'custom-toggle',
              label: 'Show DefaultImage',
              name: 'defaultImage',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-toggle',
              label: 'Show Child',
              name: 'showChildrenDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "List View Two",
            title: "List View",
            mainHeading: "List View",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardTextColor: "#000",
            // cardBgColor: "#f1f1f1",
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            ShowEnableTitle:false,
            showChildrenDate: true,
            defaultImage: false,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "10",
            imagecroptype:'8',
            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "LISTING_SH_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "sh",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
                {
          name: "List View Alt",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '6'
            },
            // {
            //   type: 'color',
            //   label: "Card Color",
            //   name: 'cardColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'cardBgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Scroll Mode',
            //   name: 'scroll',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Automatic', value: "automatic" },
            //     { label: 'Manual', value: "manual" },
            //   ]
            // },
            // {
            //   type: 'text',
            //   label: 'Scroll Count',
            //   name: 'scrollCount',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-toggle',
              label: 'Show Child',
              name: 'showChildrenDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
             {
              type: 'custom-toggle',
              label: 'Show DefaultImage',
              name: 'defaultImage',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "List View Alt",
            title: "List View",
            mainHeading: "List View",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardTextColor: "#000",
            // cardBgColor: "#f1f1f1",
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            showChildrenDate: false,
            defaultImage: false,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "6",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "LISTING_SH_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "sh",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Liveblog Show Two",
          // scriptProps: [
          //         'imagecroptype' // The crucial addition for dropdown
          //      ],
          traits: [
                    {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Liveblog Show Two",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            authorCard: false,
            imagecroptype: '4',

            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LIVEBLOG_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LIVEBLOG_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultLiveblogMsid,
                  hostId: defaultHostId,
                  tenentId: defaultTenentId,
                  fv: 1000,
                  apiType: "content",
                  cloneMapping: [
                    { from: "defaultLiveblogMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" },
                    // { from: "defaultTenentId", to: "tenentId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Amp Liveblog Show Two",
          traits: [

          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Amp Liveblog Show Two",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            authorCard: false,

            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LIVEBLOG_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LIVEBLOG_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultLiveblogMsid,
                  hostId: defaultHostId,
                  tenentId: defaultTenentId,
                  fv: 1000,
                  apiType: "content",
                  cloneMapping: [
                    { from: "defaultLiveblogMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" },
                    // { from: "defaultTenentId", to: "tenentId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "MediaList Two",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '20'
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Media List",
            name: "MediaList Two",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showDateTime: true,
            mainHeadingColor: '#000',
            cardTextColor: '#000',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            showViewAll: false,
            viewAllUrl: "",
            ShowEnableTitle:false,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            itemsPerPage: "20",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 20,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Page Not Found Two",
          traits: [
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },
        {
          name: "Page Gone Two",
          traits: [
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },
        {
          name: "ContentRestrictionsTwo",
          traits: [

            {
              type: 'custom-toggle',
              label: 'Show Image',
              name: 'ContentRestrictions',
              changeProp: 1,
              showImage: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            //   {
            //   type: 'custom-select',
            //   label: 'Select Font',
            //   name: 'ChangeFontFamily',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Montserrat', value: "Montserrat" },
            //     { label: 'Poppins', value: "Poppins" },
            //     { label: 'Roboto', value: "Roboto" },
            //   ]
            // },
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },

        {
          name: "PhotoList Two",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'View All',
            //   name: 'showViewAll',
            //   changeProp: 1,
            //   options: [
            //     { id: "ddd", name: 'True', value: true },
            //     { id: 1, name: 'False', value: false }
            //   ],
            //   showViewURLField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Viewport',
            //   name: 'showViewport',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'text',
            //   label: 'Images In Viewport',
            //   name: 'imagesInViewport',
            //   changeProp: 1,
            //   value: 'all'
            // },

            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '20'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot2',
            //   name: 'showAdSlot2',
            //   changeProp: 1,
            //   showAdSlotField2: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Photo List",
            name: "PhotoList Two",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthor: true,
            ShowEnableTitle:false,
            showDate: true,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            showAdSlot2: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adNetwork2: "google",
            headAdScript2: "",
            bodyAdScript2: "",
            bodyAdMobileScript2: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            itemsPerPage: "20",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 20,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                prime: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Podcast Two",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author Card',
            //   name: 'authorCard',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }

          ],
          media: VideoStoriesIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTags: true,
            showAuthorName: true,
            showTimeStamp: true,
            showNewsAgency: true,
            authorCard: false,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.VIDEO_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "RhsHome Two",
          traits: [
            // {
            //   type: 'text',
            //   label: "Title",
            //   name: 'mainHeading',
            //   changeProp: 1
            // },
            // {
            //   type: 'text',
            //   label: "Title URL",
            //   name: 'mainHeadingHref',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Three Line Tittle',
            //   name: 'threeLineTittle',
            //   changeProp: 1,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'True', value: true }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-select',
              label: 'Line Tittle',
              name: 'lineTittle',
              changeProp: 1,
              options: [
                { label: 'Two Line Tittle', value: "2" },
                { label: 'Three Line Tittle', value: "3" },
              ],
              value: "Three Line Tittle"
            },
              {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '7'
            },
            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Home Related News",
            title: "Home Related News",
            mainHeading: "Home Related News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardContentColor: "#000",
            cardBGColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthorName: false,
            // threeLineTittle: false,
            lineTittle: '2',
            showHeading: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "7",
            imagecroptype: '8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 7,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
                {
          name: "HomeCard List",
          traits: [
            // {
            //   type: 'text',
            //   label: "Title URL",
            //   name: 'mainHeadingHref',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "HomeCard List",
            title: "HomeCard List",
            mainHeading: "Home Card List",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardContentColor: "#000",
            cardBGColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthorName: false,
            showHeading: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype: '8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 3,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "News Social Feed",
          traits: [
            {
              type: 'text',
              label: "Heading",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Heading Left Icon msid",
              name: 'headingleftIcon',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Heading Right Icon msid",
              name: 'headingIcon',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Show Filter',
              name: 'showFilter',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Polls in Web feed',
              name: 'hidePollsWebInFeed',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-select',
              label: 'Show Date & Time',
              name: 'headerDateTimeDisplay',
              changeProp: 1,
              options: [
                { label: 'Date Only', value: 'date' },
                { label: 'Time Only', value: 'time' },
                { label: 'Date & Time', value: 'date-time' },
                { label: 'None', value: 'none' },
              ],
              value: 'none'
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '5'
            },
            {
              type: 'custom-toggle',
              label: 'Infinite Cards',
              name: 'infiniteCards',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-select',
              label: 'Default View',
              name: 'feedLayout',
              changeProp: 1,
              options: [
                { label: 'Default (Social Feed)', value: 'default' },
                { label: 'Shorts (3-col portrait grid)', value: 'shorts' },
                { label: 'Videos (2-col landscape grid)', value: 'videos' },
              ],
              value: 'default'
            },
            {
              type: 'custom-toggle',
              label: 'Show Shorts / Videos Tab Bar',
              name: 'showTabSwitcher',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Fetch Priority High (First Image)',
              name: 'fetchPriorityFirstImage',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'text',
              label: 'Image Quality Scale (0.1–1)',
              name: 'imageQualityScale',
              changeProp: 1,
              value: '1'
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            {
              type: 'custom-select',
              label: 'Article Image Resize',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                { label: 'Face-Aware', value: "8" },
                { label: 'Central', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Blurred BG', value: "75" },
              ],
              value: "8"
            },
            {
              type: 'custom-multi-select',
              label: 'Instagram - Layout',
              name: 'instagramLayoutControl',
              changeProp: 1,
              options: [
                { label: 'Hide Likes', value: "skipLike" },
                { label: 'Hide Comments', value: "skipComment" },
                { label: 'Hide Views', value: "skipView" },
                // { label: 'Hide Bookmark', value: "skipBookmark" },
                { label: 'Hide Username', value: "skiphandler" },
                { label: 'Hide Description', value: "skipDescription" },
                { label: 'Hide Comment Input', value: "skipCommentInput" },
              ],
              value: ""
            },
            {
              type: 'custom-multi-select',
              label: 'Facebook - Layout',
              name: 'fbLayoutControl',
              changeProp: 1,
              options: [
                { label: 'Hide Likes', value: "skipLike" },
                { label: 'Hide Comments', value: "skipComment" },
                { label: 'Hide Views', value: "skipView" },
                // { label: 'Hide Bookmark', value: "skipBookmark" },
                { label: 'Hide Username', value: "skiphandler" },
                { label: 'Hide Description', value: "skipDescription" },
                { label: 'Hide Comment Input', value: "skipCommentInput" },
              ],
              value: ""
            },
            {
              type: 'custom-multi-select',
              label: 'YouTube - Layout',
              name: 'youtubeLayoutControl',
              changeProp: 1,
              options: [
                { label: 'Hide Likes', value: "skipLike" },
                { label: 'Hide Comments', value: "skipComment" },
                { label: 'Hide Views', value: "skipView" },
                // { label: 'Hide Bookmark', value: "skipBookmark" },
                { label: 'Hide Title', value: "skipTitle" },
                { label: 'Hide Description', value: "skipDescription" },
                { label: 'Hide Comment Input', value: "skipCommentInput" },
                { label: 'Hide Play Icon', value: "skipPlayIcon" },
              ],
              value: ""
            },
            {
              type: 'custom-multi-select',
              label: 'News - Insights',
              name: 'authoringControlInsight',
              changeProp: 1,
              options: [
                { label: 'Hide Likes', value: "skipLike" },
                { label: 'Hide Comments', value: "skipComment" },
                { label: 'Hide Views', value: "skipView" },
                // { label: 'Hide Bookmark', value: "skipBookmark" },
                { label: 'Hide Category', value: "hideCategory" },
                { label: 'Hide Title', value: "skipTitle" },
                { label: 'Hide Description', value: "skipDescription" },
                { label: 'Hide Comment Input', value: "skipCommentInput" },
                { label: 'Hide Author Card', value: "skipAuthorCard" },
              ],
              value: ""
            },
            {
              type: 'custom-select',
              label: 'News - Layout',
              name: 'authoringLayout',
              changeProp: 1,
              options: [
                { label: 'Title Above Image / Synopsis Below', value: "top-bottom" },
                { label: 'Title Below Image / Synopsis Above', value: "bottom-top" },
                { label: 'Both Above Image', value: "top-top" },
                { label: 'Both Below Image', value: "bottom-bottom" },
              ],
              value: "bottom-bottom"
            },
            {
              type: 'text',
              label: 'Static Ad Position',
              name: 'staticAdPositionPreset',
              changeProp: 1,
              value: ""
            },
            {
              type: 'text',
              label: 'Repeat last ad interval (after belly slots)',
              name: 'repeatAdPositionPreset',
              changeProp: 1,
              value: ""
            },
            {
              type: 'text',
              label: 'Ad min height (px)',
              name: 'adMinHeight',
              changeProp: 1,
              value: ''
            },
            {
              type: 'belly-ad-accodian-trait',
              label: 'Ad Script',
              name: 'deviceType',
              showAdSlotField: true,
              changeProp: 1,
              value: '',
            },
            DATA_MAPPING_TRAIT_WITH_SOCIAL,
            SOCIAL_DATA_MAPPING_TRAIT
          ],
          media: SimilarstoriesNewIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "News Social Feed",
            title: "News Social Feed",
            mainHeading: "today's",
            version: "1000",
            headingleftIcon: "default",
            showAdSlot: true,
            userAgent: "isDesktop",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            showAdSlotField: true,
            headingIcon: "default",
            showFilter: true,
            hidePollsWebInFeed: true,
            headerDateTimeDisplay: "none",
            infiniteCards: true,
            itemsPerPage: "5",
            lazyLoadImageAfter: 5,
            // anchorLinksValue: false,
            imagecroptype: "8",
            cardBGColor: "transparent",
            instagramLayoutControl: "",
            fbLayoutControl: "",
            youtubeLayoutControl: "",
            authoringControlInsight: "",
            authoringLayout: "bottom-bottom",
            staticAdPositionPreset: "",
            repeatAdPositionPreset: "",
            adMinHeight: 0,
            fetchPriorityFirstImage: false,
            imageQualityScale: 1,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:mm TZ', publishedOrUpdated: 'published' },
            ENV: CONSTANTS.ENV.M360_STAGING,
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.SOCIAL_LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.SOCIAL_LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  msid:"125985567",
                  "hostId":467,
                  "cp":1,
                  "pp":5,
                  "apiType":"h",
                  fv:1000,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "News Social Feed V2",
          traits: [
            {
              type: 'text',
              label: 'Heading',
              name: 'mainHeading',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Heading Icon msid',
              name: 'headingIcon',
              changeProp: 1,
            },
            {
              type: 'custom-select',
              label: 'Show Date & Time',
              name: 'headerDateTimeDisplay',
              changeProp: 1,
              options: [
                { label: 'Date Only', value: 'date' },
                { label: 'Time Only', value: 'time' },
                { label: 'Date & Time', value: 'date-time' },
                { label: 'None', value: 'none' },
              ],
              value: 'none',
            },
            {
              type: 'dynamic-accordion-field',
              name: 'newsLayoutAccordion',
              label: 'Story Card Layout',
              changeProp: 1,
              fields: [
                {
                  fieldtype: 'multiselect',
                  fieldlabel: 'Card Control',
                  name: 'authoringControlInsight',
                  options: [
                    // { label: 'Hide Likes', value: 'skipLike' },
                    // { label: 'Hide Comments', value: 'skipComment' },
                    // { label: 'Hide Views', value: 'skipView' },
                    { label: 'Hide Category', value: 'hideCategory' },
                    { label: 'Hide Title', value: 'skipTitle' },
                    { label: 'Hide Description', value: 'skipDescription' },
                    // { label: 'Hide Comment Input', value: 'skipCommentInput' },
                    { label: 'Hide Author Card', value: 'skipAuthorCard' },
                  ],
                  defaultValue: [],
                },
                // {
                //   fieldtype: 'select',
                //   fieldlabel: 'Card Layout',
                //   name: 'authoringLayout',
                //   options: [
                //     { label: 'Title Above Image / Synopsis Below', value: 'top-bottom' },
                //     { label: 'Title Below Image / Synopsis Above', value: 'bottom-top' },
                //     { label: 'Both Above Image', value: 'top-top' },
                //     { label: 'Both Below Image', value: 'bottom-bottom' },
                //   ],
                //   defaultValue: 'bottom-bottom',
                // },
                {
                  fieldtype: 'select',
                  fieldlabel: 'Story Image Resize',
                  name: 'imagecroptype',
                  options: [
                    { label: 'Face-Aware', value: '8' },
                    { label: 'Central', value: '4' },
                    { label: 'White Border', value: '71' },
                    { label: 'Black Border', value: '72' },
                    { label: 'Blurred BG', value: '75' },
                  ],
                  defaultValue: '8',
                },
                { fieldtype: 'toggle', fieldlabel: 'Infinite', name: 'infiniteCards', defaultValue: true },
                { fieldtype: 'number', fieldlabel: 'Items To Be Displayed', name: 'itemsPerPage', defaultValue: 5 },
                { fieldtype: 'toggle', fieldlabel: 'Hide Polls in Web Feed', name: 'hidePollsWebInFeed', defaultValue: true },
              ],
            },
            {
              type: 'dynamic-accordion-field',
              name: 'instagramLayoutAccordion',
              label: 'Instagram Layout',
              changeProp: 1,
              fields: [
                {
                  fieldtype: 'multiselect',
                  fieldlabel: 'Card Controls',
                  name: 'instagramLayoutControl',
                  options: [
                    { label: 'Hide Likes', value: 'skipLike' },
                    { label: 'Hide Comments', value: 'skipComment' },
                    { label: 'Hide Views', value: 'skipView' },
                    // { label: 'Hide Username', value: 'skiphandler' },
                    // { label: 'Hide Description', value: 'skipDescription' },
                    // { label: 'Hide Comment Input', value: 'skipCommentInput' },
                  ],
                  defaultValue: [],
                },
                { fieldtype: 'text', fieldlabel: 'Label', name: 'instagramLabel', defaultValue: 'Indiatimes on Instagram' },
                { fieldtype: 'text', fieldlabel: 'Followers', name: 'instagramFollowers', defaultValue: '1.4m followers' },
                { fieldtype: 'heading', fieldlabel: 'CTA', name: 'instagramCtaHeading' },
                { fieldtype: 'text', fieldlabel: 'Name', name: 'instagramCtaName', defaultValue: 'Follow' },
                { fieldtype: 'text', fieldlabel: 'Link', name: 'instagramCtaLink', defaultValue: 'https://www.instagram.com/indiatimes/' },
                { fieldtype: 'toggle', fieldlabel: 'Infinite', name: 'instagramInfinite', defaultValue: true },
                // { fieldtype: 'toggle', fieldlabel: 'Client / Server', name: 'instagramClientServer', defaultValue: false },
                { fieldtype: 'number', fieldlabel: 'Items To Be Displayed', name: 'instagramItemsToDisplay', defaultValue: 5 },
                { fieldtype: 'number', fieldlabel: 'Insert Position(After Only Story)', name: 'instagramInsertPosition', defaultValue: 5 },
                {
                  fieldtype: 'multiselect',
                  fieldlabel: 'Handler\'s Name',
                  name: 'igsct',
                  defaultValue: [],
                  optionsApi: { 
                    url: RENDERING_ENDPOINTS.SOCIAL_CHANNEL_LIST, 
                    labelKey: 'name', valueKey: 'name' 
                  },
                },
                {
                  fieldtype: 'text',
                  fieldlabel: 'title/caption include Name',
                  name: 'igsft',
                  defaultValue: [],
                },
                {
                  fieldtype: 'select',
                  fieldlabel: 'Filter Media Type',
                  name: 'igsmt',
                  options: [
                    { label: 'Exclude videos', value: 'ex-videos' },
                    { label: 'Videos', value: 'videos' },
                    { label: 'All', value: 0 },
                  ],
                  defaultValue: ''
                }
              ],
            },
            {
              type: 'dynamic-accordion-field',
              name: 'youtubeLayoutAccordion',
              label: 'YouTube Layout',
              changeProp: 1,
              fields: [
                {
                  fieldtype: 'multiselect',
                  fieldlabel: 'Card Controls',
                  name: 'youtubeLayoutControl',
                  options: [
                    { label: 'Hide Likes', value: 'skipLike' },
                    { label: 'Hide Comments', value: 'skipComment' },
                    { label: 'Hide Views', value: 'skipView' },
                    { label: 'Hide Title', value: 'skipTitle' },
                    { label: 'Hide Description', value: 'skipDescription' },
                    { label: 'Hide Comment Input', value: 'skipCommentInput' },
                    { label: 'Hide Play Icon', value: 'skipPlayIcon' },
                  ],
                  defaultValue: [],
                },
                { fieldtype: 'text', fieldlabel: 'Label', name: 'youtubeLabel', defaultValue: 'Indiatimes on YouTube' },
                { fieldtype: 'text', fieldlabel: 'Followers', name: 'youtubeFollowers', defaultValue: '1.01M subscribers' },
                { fieldtype: 'heading', fieldlabel: 'CTA', name: 'youtubeCtaHeading' },
                { fieldtype: 'text', fieldlabel: 'Name', name: 'youtubeCtaName', defaultValue: 'Subscribe' },
                { fieldtype: 'text', fieldlabel: 'Link', name: 'youtubeCtaLink', defaultValue: 'https://www.youtube.com/indiatimes' },
                { fieldtype: 'toggle', fieldlabel: 'Infinite', name: 'youtubeInfinite', defaultValue: true },
                // { fieldtype: 'toggle', fieldlabel: 'Client / Server', name: 'youtubeClientServer', defaultValue: false },
                { fieldtype: 'number', fieldlabel: 'Items To Be Displayed', name: 'youtubeItemsToDisplay', defaultValue: 5 },
                { fieldtype: 'number', fieldlabel: 'Insert Position(After Only Story)', name: 'youtubeInsertPosition', defaultValue: 9 },
                {
                  fieldtype: 'multiselect',
                  fieldlabel: 'Handler\'s Name',
                  name: 'ytsct',
                  defaultValue: [],
                  optionsApi: { 
                    url: RENDERING_ENDPOINTS.SOCIAL_CHANNEL_LIST, 
                    labelKey: 'name', valueKey: 'name' 
                  },
                },
                {
                  fieldtype: 'text',
                  fieldlabel: 'title/caption include Name',
                  name: 'ytsft',
                  defaultValue: [],
                },
                {
                  fieldtype: 'select',
                  fieldlabel: 'Filter Media Type',
                  name: 'ytsmt',
                  options: [
                    { label: 'Exclude videos', value: 'ex-videos' },
                    { label: 'Videos', value: 'videos' },
                    { label: 'All', value: 0 },
                  ],
                  defaultValue: ''
                }
              ],
            },

            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT_WITH_SOCIAL,
          ],
          media: SimilarstoriesNewIcon,
          attributes: {
            CONSTANTS,
            name: 'News Social Feed V2',
            title: 'News Social Feed V2',
            mainHeading: "today's",
            headingIcon: '',
            version: '1000',
            headerDateTimeDisplay: 'none',
            authoringControlInsight: [],
            authoringLayout: 'bottom-bottom',
            imagecroptype: '8',
            infiniteCards: true,
            itemsPerPage: 5,
            hidePollsWebInFeed: true,
            youtubeLayoutControl: [],
            youtubeLabel: 'Indiatimes on YouTube',
            youtubeFollowers: '1.01M subscribers',
            youtubeCtaName: 'Subscribe',
            youtubeCtaLink: 'https://www.youtube.com/indiatimes',
            youtubeInfinite: true,
            youtubeClientServer: false,
            youtubeItemsToDisplay: 5,
            youtubeInsertPosition: 9,
            instagramLayoutControl: [],
            instagramLabel: 'Indiatimes on Instagram',
            instagramFollowers: '1.4m followers',
            instagramCtaName: 'Follow',
            instagramCtaLink: 'https://www.instagram.com/indiatimes/',
            instagramInfinite: true,
            instagramClientServer: false,
            instagramItemsToDisplay: 5,
            instagramInsertPosition: 5,
            showAdSlot: true,
            adNetwork: 'google',
            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: 'Belly',
            showAdSlotField: true,
            adMinHeight: 270,
            fetchPriorityFirstImage: true,
            imageQualityScale: 1,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:mm TZ', publishedOrUpdated: 'published' },
            ENV: CONSTANTS.ENV.M360_STAGING,
            ENDPOINTS: [
              {
                name: 'MAIN',
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  msid: '125985567',
                  hostId: 467,
                  cp: 1,
                  pp: 5,
                  apiType: 'h',
                  fv: 1000,
                  cloneMapping: [{ from: 'defaultHostId', to: 'hostId' }],
                },
              },
            ],
          },
        },
        {
          name: "Vertical List Four",
          traits: [
            {
              type: 'text',
              label: "Heading",
              name: 'heading',
              changeProp: 1,
              value: 'Latest stories'
            },
            {
              type: 'text',
              label: "Heading Icon msid",
              name: 'headingIcon',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Show Icon as heading icon',
              name: 'showHeadingIcon',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-select',
              label: 'Image Resize',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                { label: 'Face-Aware', value: "8" },
                { label: 'Central', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Blurred BG', value: "75" },
              ],
              value: "8"
            },
            {
              type: 'text',
              label: 'Items to be Displayed',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '5'
            },
            // {
            //   type: 'custom-select',
            //   label: 'Card Layout',
            //   name: 'cardLayout',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Image Overlay', value: 'overlay' },
            //     { label: 'Horizontal', value: 'horizontal' },
            //   ],
            //   value: 'overlay'
            // },
            {
              type: 'custom-toggle',
              label: 'Hide Category',
              name: 'hideCategory',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Label',
              name: 'hideLabel',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Author',
              name: 'hideAuthor',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Date & Time',
              name: 'hideDateTime',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () { return !this.value; }
            },
            DATA_MAPPING_TRAIT
          ],
          media: SimilarstoriesNewIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Vertical List Four",
            title: "Vertical List Four",
            heading: "Latest stories",
            headingIcon: "",
            showHeadingIcon: true,
            version: "1000",
            imagecroptype: "8",
            itemsPerPage: "5",
            cardLayout: "overlay",
            hideCategory: false,
            hideLabel: false,
            hideAuthor: false,
            hideDateTime: false,
            anchorLinksValue: false,
            showAdSlot: true,
            adNetwork: 'google',
            adConfigurations: {},
            adSlotLable: 'Belly',
            maxAdsAccordian: 8,
            showAdSlotField: true,
            adMinHeight: 270,
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: "all",
                  st: "date",
                  so: "dsc",
                  cp: 1,
                  pp: 5,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Horizontal List Four",
          traits: [
            {
              type: 'text',
              label: "Heading",
              name: 'heading',
              changeProp: 1,
              value: 'you may also like'
            },
            // {
            //   type: 'text',
            //   label: "Heading Icon msid",
            //   name: 'headingIcon',
            //   changeProp: 1
            // },
            {
              type: 'custom-select',
              label: 'Image Resize',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                { label: 'Face-Aware', value: "8" },
                { label: 'Central', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Blurred BG', value: "75" },
              ],
              value: "8"
            },
            {
              type: 'text',
              label: 'Items to be Displayed',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '8'
            },
            {
              type: 'custom-select',
              label: 'Rows',
              name: 'rows',
              changeProp: 1,
              options: [
                { label: '1 Row', value: '1' },
                { label: '2 Rows', value: '2' },
              ],
              value: '2'
            },
            {
              type: 'custom-toggle',
              label: 'Infinite Scroll',
              name: 'infiniteScroll',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Category',
              name: 'hideCategory',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Label',
              name: 'hideLabel',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Author',
              name: 'hideAuthor',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Hide Date & Time',
              name: 'hideDateTime',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            DATA_MAPPING_TRAIT
          ],
          media: SimilarstoriesNewIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Horizontal List Four",
            title: "Horizontal List Four",
            heading: "you may also like",
            // headingIcon: "",
            version: "1000",
            imagecroptype: "8",
            itemsPerPage: "8",
            rows: "2",
            infiniteScroll: true,
            hideCategory: false,
            hideLabel: false,
            hideAuthor: false,
            hideDateTime: false,
            anchorLinksValue: false,
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: "all",
                  st: "date",
                  so: "dsc",
                  cp: 1,
                  pp: 8,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Main Menu Four",
          traits: [
            {
              type: 'text',
              label: 'Component name',
              name: 'componentName',
              changeProp: 1,
              value: ''
            },
            {
              type: 'text',
              label: 'Menu heading',
              name: 'menuHeading',
              changeProp: 1,
              value: ''
            },
            {
              type: 'text',
              label: 'Menu heading logo msid',
              name: 'menuHeadingLogoMsid',
              changeProp: 1,
              value: ''
            },
            {
              type: 'custom-item-list',
              label: 'Menu Items',
              name: 'menuItems',
              collapsible: true,
              changeProp: 1,
              itemFields: [
                { key: 'name', label: 'Name', required: true },
                { key: 'path', label: 'Path / URL', required: true },
                { key: 'logoMsid', label: 'Logo msid' }
              ],
              defaultItem: {
                name: '',
                path: '',
                logoMsid: ''
              },
              value: []
            },
            {
              type: 'custom-checkbox-group',
              label: 'Display On',
              name: 'displayOn',
              title: 'Display On',
              changeProp: 1,
              groups: [
                {
                  title: 'Web',
                  options: [
                    { name: 'webLeftSidebar', label: 'Left Sidebar' },
                   /* { name: 'webHamburger', label: 'Hamburger Menu' },*/
                   /* { name: 'webFloating', label: 'Sticky/Floating Menu' }*/
                  ]
                },
                {
                  title: 'Mobile',
                  options: [
                    { name: 'mobileHamburger', label: 'Hamburger Menu' },
                    { name: 'mobileFloating', label: 'Sticky/Floating Menu' }
                  ]
                }
              ]
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // }
          ],
          media: MainMenuIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Main Menu Four",
            title: "Header",
            version: "1000",
            componentName: "",
            menuHeading: "",
            menuHeadingLogoMsid: "",
            menuItems: [],
            webLeftSidebar: true,
            //webHamburger: false,
            //webFloating: false,
            mobileHamburger: true,
            mobileFloating: false,
            // anchorLinksValue: false,
            ENV: CONSTANTS.ENV.M360_STAGING,
            ENDPOINTS: [
              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Webstories List Four",
          traits: [
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '10'
            },
            {
              type: 'custom-toggle',
              label: 'Lazy Load Images',
              name: 'lazyLoad',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Image Quality Scale (0.1–1)',
              name: 'imageQualityScale',
              changeProp: 1,
              value: '1'
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Webstories List Four",
            title: "Webstories List Four",
            version: "1000",
            anchorLinksValue: false,
            lazyLoad: true,
            imageQualityScale: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            itemsPerPage: '10',
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Content Tags List",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-item-list',
              label: 'Tags',
              name: 'tags',
              changeProp: 1,
              itemFields: [
                { key: 'label', label: 'Label', onChangeFill: 
                  { fn: (v) => `/topic/${toSlugify(v)}`, target: 'url' } 
                }, 
                { key: 'url', label: 'URL' }
              ],
              defaultItem: { label: '', url: '#' },
              value: []
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Show Tags',
            //   name: 'showTags',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // }
          ],
          media: ContactTagIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Content Tags List",
            title: "",
            version: "1000",
            tags: [],
            showTags: true,
            anchorLinksValue: false
          }
        },
        {
          name: "Poll Card",
          traits: [
            {
              type: 'text',
              label: "Heading",
              name: 'heading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Heading Icon msid",
              name: 'headingIcon',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Hide on Mweb',
              name: 'hideOnMweb',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '10'
            },
            DATA_MAPPING_TRAIT
          ],
          media: PollIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Poll Card",
            title: "Poll Card",
            version: "1000",
            heading: "vibe check",
            anchorLinksValue: false,
            hideOnMweb: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            selectorOnly:[
              {label: 'Poll', value: 'poll'}
            ],
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  msid: defaultListingMsid,
                  hostId: defaultHostId,
                  cp: 1,
                  pp: 10,
                  ct: ["poll"],
                  st: "date",
                  so: "dsc",
                  apiType: "h",
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Dynamic List",
          traits: [
            {
              type: 'text',
              label: "Heading",
              name: 'heading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Heading Icon msid",
              name: 'headingIcon',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Hide on Mweb',
              name: 'hideOnMweb',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            {
              type: 'custom-item-list',
              label: 'List',
              name: 'items',
              changeProp: 1,
              itemFields: [
                { key: 'image', label: 'Avatar' }, { key: 'logo', label: 'Logo' },
                { key: 'hl', label: 'Channel Name' }, { key: 'desc', label: 'Followers' },
                { key: 'href', label: 'Link' }
              ],
              defaultItem: { image: '', logo: '', hl: '', desc: '', href:'' },
              value: []
            }
          ],
          media: DynamicListIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Dynamic List",
            title: "Dynamic List",
            heading: "Dynamic List",
            version: "1000",
            items: [],
            anchorLinksValue: false,
            hideOnMweb: false,
          }
        },
        {
          name: "Dynamic Form",
          traits: [
            {
              type: 'color',
              label: "BG Color",
              name: 'DynamicBgColor',
              changeProp: 1
            },
            {
              type: "text",
              label: "Main Heading",
              name: "mainHeading",
              changeProp: 1
            },
            {
              type: "text",
              label: "Sub Heading",
              name: "subHeading",
              changeProp: 1
            },
            {
              type: "dynamic-form-fields",
              label: "Fields",
              name: "fields",
              changeProp: 1,
              value: []
            },
            // {
            //   type: "custom-toggle",
            //   label: "Show Labels",
            //   name: "showLabels",
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            {
              type: "submit-button-group",
              label: "Submit Button",
              name: "submitButtonGroup",
              changeProp: 1
            }
          ],
          media: DynamicListIcon,
          attributes: {
            name: "Dynamic Form",
            title: "Dynamic Form",
            version: "1000",
            mainHeading: "Contact Us",
            subHeading: "Share your details and we will get back to you.",
            showLabels: true,
            apiBaseUrl: "",
            apiBody: "",
            apiHeaders: "",
            clickAction: "Submit",
            submitText: "Submit",
            successMessage: "",
            otpSubmitText: "Verify OTP",
            otpApiBaseUrl: "",
            otpApiBody: "",
            otpSuccessMessage: "",
            otpFieldLabel: "OTP",
            otpFieldPayloadName: "",
            enableResendOtp: false,
            DynamicBgColor: "#f3f8fe",
            maxFields: 10,
            fields: [
              {
                fieldType: "text",
                label: "Text Field 1",
                placeholder: "Enter text",
                required: false,
                name: "textField1",
                id: "text-field-1",
                disabled: false
              },
              {
                fieldType: "select",
                label: "Select Field 1",
                required: false,
                name: "selectField1",
                id: "select-field-1",
                defaultValue: "",
                optionsText: "Option 1\nOption 2\nOption 3"
              }
            ]
          }
        },
        {
          name: "Header Four",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Enable L1 menu',
              name: 'newHeaderUi',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'number',
              label: 'Number of L1 Menus (max 5)',
              name: 'l1MenuCount',
              changeProp: 1,
              min: 0,
              max: 5,
              value: 5
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'MWeb',
            //   name: 'mweb',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            {
              type: 'custom-select',
              label: 'Show Date & Time',
              name: 'headerDateTimeDisplay',
              changeProp: 1,
              options: [
                { label: 'Date Only', value: 'date' },
                { label: 'Time Only', value: 'time' },
                { label: 'Date & Time', value: 'date-time' },
                { label: 'None', value: 'none' },
              ],
              value: 'none',
            },
            {
              type: 'text',
              label: 'Override Logo msid',
              name: 'logoMsid',
              changeProp: 1,
              value: ''
            },
            {
              type: 'custom-toggle',
              label: 'Sticky Header',
              name: 'stickyHeader',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Jump To Top',
              name: 'jumpToTop',
              changeProp: 1,
              isNotChecked: function () { return !this.value; }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Hide Menu On Web',
            //   name: 'hideMenuOnWeb',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () { return !this.value; }
            // }
          ],
          media: GridViewIcon,
          attributes: {
            CONSTANTS: CONSTANTS,
            name: "Header Four",
            version: "1000",
            title: "Header",
            logoMsid: "",
            newHeaderUi: false,
            l1MenuCount: 5,
            mweb: false,
            headerDateTimeDisplay: "none",
            stickyHeader: false,
            jumpToTop: false,
            anchorLinksValue: false,
            // hideMenuOnWeb: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "CUSTOM_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ],
                  key: "custom-menu",
                  fv: 1
                }
              },
              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Quiz List Four",
          traits: [
            {
              type: 'text',
              label: 'Items per page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '10'
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "next"
            },
            {
              type: 'text',
              label: 'Trending Label',
              name: 'trendingLabel',
              changeProp: 1,
              value: 'Trending right now'
            },
            {
              type: 'custom-toggle',
              label: 'Show Total Questions',
              name: 'showTotalQuestions',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Total Time',
              name: 'showQuizTime',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              label: 'Image Quality Scale (0.1–1)',
              name: 'imageQualityScale',
              changeProp: 1,
              value: '1'
            },
            DATA_MAPPING_TRAIT
          ],
          media: PollIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Quiz List Four",
            title: "Quiz List Four",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            version: "1000",
            imageQualityScale: 1,
            itemsPerPage: "10",
            type1: "next",
            showTotalQuestions: false,
            showQuizTime: false,
            quizListUrl: "",
            anchorLinksValue: false,
            trendingLabel: "Trending right now",
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            selectorOnly: [
              {label: 'Quiz', value: 'quiz'},
              {label: 'Survey', value: 'survey'}
            ],
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: ["quiz"],
                  st: "date",
                  so: "dsc",
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "CATEGORIES_LIST",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API_SH,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API_SH,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "sh",
                  ct: ["quiz"],
                  st: "rank",
                  so: "dsc",
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Quiz Related Four",
          traits: [
            {
              type: 'text',
              label: 'Items Per Page',
              name: 'itemsPerPage',
              changeProp: 1
            },
            {
              type: 'text',
              label: 'Section Title',
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Show Total Questions',
              name: 'showTotalQuestions',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Total Time',
              name: 'showQuizTime',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: PollIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Quiz Related Four",
            title: "Quiz Related Four",
            version: "1000",
            itemsPerPage: "10",
            mainHeading: "Related Quizzes",
            showTotalQuestions: false,
            showQuizTime: false,
            mainHeadingHref: "",
            mainHeadingColor: "#1a0a2e",
            showViewAll: false,
            viewAllUrl: "",
            anchorLinksValue: false,
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            selectorOnly: [
              {label: 'Quiz', value: 'quiz'},
              {label: 'Survey', value: 'survey'}
            ],
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: ["quiz"],
                  st: "date",
                  so: "dsc",
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Quiz Show Four",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Show Progress Bar',
              name: 'showProgressBar',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Total Questions',
              name: 'showTotalQuestions',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Quiz Count',
              name: 'showQuizCount',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Options Layout',
              name: 'optionsLayout',
              changeProp: 1,
              options: [
                { label: 'Column (default)', value: 'column' },
                { label: 'Grid 2×2', value: 'grid2x2' },
              ],
              value: 'column'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'select',
              label: 'Ad position',
              name: 'adPosition',
              changeProp: 1,
              options: [
                { id: 'before_options', name: 'Before Options' },
                { id: 'after_options', name: 'After Options' },
              ],
            },
            {
              type: 'text',
              label: 'Redirect URL (Quit / Quiz Home)',
              name: 'quizListUrl',
              changeProp: 1,
              placeholder: 'https://example.com/quizzes'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: false,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Image Quality Scale (0.1–1)',
              name: 'imageQualityScale',
              changeProp: 1,
              value: '1'
            }
            // DATA_MAPPING_TRAIT
          ],
          media: PollIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            name: "Quiz Show Four",
            title: "Quiz Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            accentColorHex: "#d4ff00",
            categoryLabel: "Quiz",
            durationMinEstimate: "5",
            showProgressBar: false,
            showTotalQuestions: false,
            showQuizCount: true,
            optionsLayout: "column",
            imageQualityScale: 1,
            showAdSlot: false,
            adSlotLable: "Ad",
            adConfigurations: {},
            adNetwork: "google",
            adSize: "300*250",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adPosition: "after_options",
            quizListUrl: "",
            relatedHeading: "More Quizzes",
            relatedHeadingColor: "#1a0a2e",
            relatedShowViewAll: false,
            relatedViewAllUrl: "",
            relatedMsid: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.QUIZ_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.QUIZ_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultQuizId,
                  hostId: defaultHostId,
                  fv: 1000,
                  links: 1,
                  count: 1,
                  cloneMapping: [
                    { from: "defaultQuizId", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Survey Show Four",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Show Progress Bar',
              name: 'showProgressBar',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Total Questions',
              name: 'showTotalQuestions',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Show Quiz Count',
              name: 'showQuizCount',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Options Layout',
              name: 'optionsLayout',
              changeProp: 1,
              options: [
                { label: 'Column (default)', value: 'column' },
                { label: 'Grid 2×2', value: 'grid2x2' },
              ],
              value: 'column'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'select',
              label: 'Ad position',
              name: 'adPosition',
              changeProp: 1,
              options: [
                { id: 'before_options', name: 'Before Options' },
                { id: 'after_options', name: 'After Options' },
              ],
            },
            {
              type: 'text',
              label: 'Redirect URL (Quit / Quiz Home)',
              name: 'quizListUrl',
              changeProp: 1,
              placeholder: 'https://example.com/quizzes'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: false,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
            // DATA_MAPPING_TRAIT
          ],
          media: PollIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            name: "Survey Show Four",
            title: "Survey Show",
            version: "1000",
            accentColorHex: "#d4ff00",
            categoryLabel: "Survey",
            durationMinEstimate: "5",
            showProgressBar: false,
            showTotalQuestions: false,
            showQuizCount: true,
            optionsLayout: "column",
            showAdSlot: false,
            adSlotLable: "Ad",
            adConfigurations: {},
            adNetwork: "google",
            adSize: "300*250",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adPosition: "after_options",
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.SURVEY_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.SURVEY_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultSurveyId,
                  hostId: defaultHostId,
                  fv: 1000,
                  links: 1,
                  count: 1,
                  cloneMapping: [
                    { from: "defaultSurveyId", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "RhsHome Other Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Heading',
              name: 'showHeading',
              changeProp: 1,
              showHeading: false,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Related News",
            title: "Related News",
            mainHeading: "Related News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardContentColor: "#000",
            cardBGColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthorName: true,
            showHeading: true,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype:'8',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 8,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

                {
          name: "Rhs Wight",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Logo Url / msid",
              name: 'mainLogo',
              changeProp: 1
            },
                        {
              type: 'text',
              label: "SVG Icon",
              name: 'iconwight',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Utm Parameters",
              name: 'utmparameters',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Heading',
            //   name: 'showHeading',
            //   changeProp: 1,
            //   showHeading: false,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              },
              
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '3'
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Indiatimes Lifestyle",
            title: "Indiatimes Lifestyle",
            mainHeading: "Indiatimes Lifestyle",
            version: "1000",
            mainLogo: "",
            iconwight: "",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardContentColor: "#000",
            cardBGColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthorName: true,
            // showHeading: true,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            utmparameters:'',
            itemsPerPage: "3",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 3,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {

          name: "Slide Show Two",
          // scriptProps: [
          //   'imagecroptype' // The crucial addition for dropdown
          // ],
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                 //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: SlideShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Slide Show Two',
            name: 'Slide Show Two',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            background: '#fff',
            showAdSlot: false,
            authorCard: false,
            imagecroptype: '4',
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                preview: false,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                preview: false,
                prime: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },




        {
          name: "Static Page Two",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Title',
              name: 'showTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: StaticPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            background: '#fff',
            version: "1000",
            title: "Static Page Two",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTitle: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultStaticMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultStaticMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ],
                }
              }
            ]
          }
        },

        {
          name: "Breaking News Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'BGColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Content Color",
              name: 'cardContentColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Card BG Color",
              name: 'cardBGColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: BreakingNewsIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Trending News",
            title: "Trending News",
            mainHeading: "Trending News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            // cardBGColor: "pink",
            cardBGColor: "#fff",
            cardActiveColor: "#fff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Video Carousel",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'BGColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Content Color",
            //   name: 'cardContentColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card BG Color",
            //   name: 'cardBGColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: firstBigCarousel,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Video Carousel",
            title: "Video Carousel",
            mainHeading: "Video Carousel",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardBGColor: "#fff",
            cardActiveColor: "#fff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
                {
          name: "Video Carousel Center",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'BGColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Content Color",
            //   name: 'cardContentColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card BG Color",
            //   name: 'cardBGColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            // {
            //   type: 'text',
            //   label: 'Scroll Count',
            //   name: 'scrollCount',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Piroity',
              name: 'ImagePiroity',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-select',
              label: 'Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "8"
            },
            DATA_MAPPING_TRAIT
          ],
          media: centerCarousal,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Video Carousel Center",
            title: "Video Carousel Center",
            mainHeading: "Video Carousel Center",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardBGColor: "#fff",
            cardActiveColor: "#fff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            imagecroptype:'8',
            ImagePiroity:'false',

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
                {
          name: "Video Reel",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'cardBGColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "Card Color",
            //   name: 'cardActiveColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: videoReel,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Video Reel",
            title: "Video Reel",
            mainHeading: "Video Reel",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            showDate: true,
            // cardBGColor: "pink",
            cardBGColor: "#EFEFEF",
            cardActiveColor: "#ffffff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: ['video','audio'],
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Video Show Two",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }

          ],
          media: VideoStoriesIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTags: true,
            showAuthorName: true,
            showTimeStamp: true,
            showNewsAgency: true,
            authorCard: false,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.VIDEO_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "WebStories Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'cardBGColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "Card Color",
            //   name: 'cardActiveColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: CarouselCardIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Web Stories",
            title: "Web Stories",
            mainHeading: "Web Stories",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            showDate: true,
            // cardBGColor: "pink",
            cardBGColor: "#EFEFEF",
            cardActiveColor: "#ffffff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "WebStoriesList Two",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author',
            //   name: 'showAuthor',
            //   changeProp: 1,
            //   showAuthor:true,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'color',
            //   label: "Background Color",
            //   name: 'BgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card BG Color",
            //   name: 'cardBGColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Scroll Mode',
            //   name: 'scroll',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Automatic', value: "automatic" },
            //     { label: 'Manual', value: "manual" },
            //   ]
            // },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '20'
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: WebstoriesCardList,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Web Stories List",
            title: "Web Stories List",
            mainHeading: "Web Stories List",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            BgColor: "#ffffff",
            cardBgColor: "transparent",
            cardTextColor: "#555555",
            scroll: "automatic",
            showDate: true,
            ShowEnableTitle:false,
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "20",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 20,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },


        // -------------------------End---theme-two-comoponents------------------------------------------------
        // ----------------------------theme-two-amp-comoponents------------------------------------------------
        {
          name: "Article Show Two Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Synopsis Abov Img',
              name: 'SynopsisAbovImg',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author Card',
            //   name: 'authorCard',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              options: [
                { id: 7, name: 'True', value: true },
                { id: 8, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 9, name: 'True', value: true },
                { id: 19, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Caption',
              name: 'showImageCaption',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            name: "Article Show Two Amp",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            SynopsisAbovImg:false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showImageCaption:false,
            // authorCard: false,
            isImageTitle: true,
            // GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultArticleMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Footer Two Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'About Site',
              name: 'showAbout',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcons',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'copyRightText',
              name: 'showSocialIcons',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Static Pages',
              name: 'showStaticPages',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: FooterIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            showAbout: true,
            showSocialIcons: true,
            copyRightText: "",
            footerLogo: "",
            title: "Footer",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "FOOTER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.FOOTER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.FOOTER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Header Two Amp",
          media: HeaderIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
          ]

        },
        {
          name: "Photo Show Two Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: SlideShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Photo Show Two Amp',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            showAdSlot: false,
            background: '#fff',
            authorCard: false,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                preview: false,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                preview: false,
                prime: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Video Show Two Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            }
          ],
          media: SlideShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show Two Amp',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            showAdSlot: false,
            authorCard: false,
            background: '#fff',
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            showViewport: true,
            imagesInViewport: "all",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                isSSR: true,
                SSRDataObj: null,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        // -------------------------End---theme-two-amp-comoponents------------------------------------------------
        // ----------------------------theme-one-comoponents------------------------------------------------

        {
          name: "Ad Scripts",
          media: AddScriptIcon,
          traits: [
            //   {
            //   type: 'custom-textarea',
            //   label: 'Header Script',
            //   name: 'headAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script',
            //   name: 'bodyAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script (Mobile)',
            //   name: 'bodyAdMobileScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Ad Size',
            //   name: 'adSize',
            //   changeProp: 1,
            //   value: '300*100',
            //   options: [
            //     { label: '300*100', value: "300*100" },
            //     { label: '300*250', value: "300*250" },
            //     { label: '970*90', value: "970*90" },
            //   ]
            // },
            {
              type: 'belly-ad-accodian-trait',
              label: 'Ad Script',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }
          ],
          attributes: {
            title: "Ad Scripts",
            name: "Ad Scripts",
            version: "1000",
            adSize: "300*100",
            // headAdScript: "",
            // bodyAdScript: "",
            showAdSlot: true,
            bodyAdMobileScript: "",
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
          }
        },
 
        {
          name: "Ad Scripts Amp",
          media: AddScriptIcon,
          traits: [
            // {
            //   type: 'custom-textarea',
            //   label: 'Header Script',
            //   name: 'headAdScript',
            //   changeProp: 1,  
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script',
            //   name: 'bodyAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script (Mobile)',
            //   name: 'bodyAdMobileScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Ad Size',
            //   name: 'adSize',
            //   changeProp: 1,
            //   value: '300*100',
            //   options: [
            //     { label: '300*100', value: "300*100" },
            //     { label: '300*250', value: "300*250" },
            //   ]
            // },
            {
              type: 'belly-ad-accodian-trait',
              label: 'Ad Script',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }],
          attributes: {
            title: "Add Scripts",
            name: "Ad Scripts Amp",
            version: "1000",
            adSize: "300*100",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showAdSlot: true,
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
          }
        },

        {
          name: "Left Gutter Ads",
          media: AddScriptIcon,
          traits: [
            {
              type: 'belly-ad-accodian-trait',
              label: 'Gutter Ads',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }
          ],
          attributes: {
            title: "Left Gutter Ads",
            name: "Left Gutter Ads",
            version: "1000",
            adSize: "300*100",
            // headAdScript: "",
            // bodyAdScript: "",
            showAdSlot: true,
            bodyAdMobileScript: "",
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            userAgent: "isDesktop"
          }
        },

        {
          name: "Right Gutter Ads",
          media: AddScriptIcon,
          traits: [
            {
              type: 'belly-ad-accodian-trait',
              label: 'Gutter Ads',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }
          ],
          attributes: {
            title: "Right Gutter Ads",
            name: "Right Gutter Ads",
            version: "1000",
            adSize: "300*100",
            // headAdScript: "",
            // bodyAdScript: "",
            showAdSlot: true,
            bodyAdMobileScript: "",
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            userAgent: "isDesktop"
          }
        },

        {
          name: "Article Show",
          // scriptProps: [
          //   'imagecroptype' // The crucial addition for dropdown
          // ],
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              options: [
                { id: 7, name: 'True', value: true },
                { id: 8, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 9, name: 'True', value: true },
                { id: 19, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                 //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            authorCard: true,
            imagecroptype: '4',
            isImageTitle: true,

            // GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultArticleMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Article Show Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author Card',
            //   name: 'authorCard',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              options: [
                { id: 7, name: 'True', value: true },
                { id: 8, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 9, name: 'True', value: true },
                { id: 19, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            name: "Article Show Amp",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            // authorCard: false,
            isImageTitle: true,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },

            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultArticleMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Author Show",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Department',
              name: 'showDepartment',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcon',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: AuthorShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Author Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showSocialIcon: true,
            showDepartment: true,
            background: '#fff',
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.AUTHOR_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.AUTHOR_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultAuthorID,
                  fv: 1000,
                  hostId: defaultHostId,
                  cloneMapping: [
                    { from: "defaultAuthorID", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Breaking News",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Card Content Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Card BG Color",
              name: 'cardBGColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: BreakingNewsIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Breaking News",
            title: "Breaking News",
            mainHeading: "Breaking News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            // cardBGColor: "pink",
            cardBGColor: "",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },



        {
          name: "Bread Crumbs",
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "BreadCrumbs",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            seperator: ">>",
            categoryName: "",
            includeTitle: true,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          media: BreadCrumbsIcon,
          traits: [
            {
              type: 'custom-select',
              label: 'Seperator',
              name: 'seperator',
              changeProp: 1,
              options: [
                { label: '>>', value: ">>" },
                { label: '>', value: ">" },
                { label: '/', value: "/" }
              ],
              value: ">>"
            },
            {
              type: 'text',
              name: 'categoryName',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Include Title',
              name: 'includeTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },

        {
          name: "Bread Crumbs Amp",
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "BreadCrumbs",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            seperator: ">>",
            categoryName: "",
            includeTitle: true,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          media: BreadCrumbsIcon,
          traits: [
            {
              type: 'custom-select',
              label: 'Seperator',
              name: 'seperator',
              changeProp: 1,
              options: [
                { label: '>>', value: ">>" },
                { label: '>', value: ">" },
                { label: '/', value: "/" }
              ],
              value: ">>"
            },
            {
              type: 'text',
              name: 'categoryName',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Include Title',
              name: 'includeTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },

        {
          name: "Carousel Card Block",
          media: CarouselCardIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Section Title",
            version: "1000",
            name: "Carousel Card",
            showDateTime: true,
            scrollMode: "automatic",
            scrollCount: 1,
            background: '#fff',
            stylesheets: [],
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            showViewAll: false,
            isCarousel: true,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            viewAllUrl: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 27,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
        },
        {
          name: "Circular Card Carousel",
          media: WebstoriesCircle,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            // CONSTANTS: CONSTANTS.API_URL,
            CONSTANTS: CONSTANTS,
            title: "Section Title",
            version: "1000",
            scrollMode: "automatic",
            scrollCount: 1,
            background: '#fff',
            stylesheets: [],
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showViewAll: false,
            isCarousel: true,
            isCircular: true,
            viewAllUrl: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  authorid: defaultAuthorID,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 27,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultAuthorID", to: "authorid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scrollMode',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ]
        },
        {
          name: "Footer",
          traits: [
            {
              type: 'custom-toggle',
              label: 'About Site',
              name: 'showAbout',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcons',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'copyRightText',
              name: 'showSocialIcons',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Static Pages',
              name: 'showStaticPages',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: FooterIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            showAbout: true,
            showSocialIcons: true,
            copyRightText: "",
            footerLogo: "",
            title: "Footer",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            noOfHeaderItems: 12,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "FOOTER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.FOOTER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.FOOTER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Footer Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'About Site',
              name: 'showAbout',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcons',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'copyRightText',
              name: 'showSocialIcons',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Static Pages',
              name: 'showStaticPages',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ],
          media: FooterIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            showAbout: true,
            showSocialIcons: true,
            copyRightText: "",
            footerLogo: "",
            title: "Footer",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "FOOTER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.FOOTER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.FOOTER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Grid View",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              // value: "page"   //This is making default pagination value
            },
            // {
            //   type: 'text',
            //   label: 'Items per-page',
            //   name: 'itemsPerPage',
            //   changeProp: 1,
            //   value: '4'
            // },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIconLess,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Quick Views",
            name: "Grid View",
            version: "1000",
            showDateTime: true,
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            ShowEnableTitle:false,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            // itemsPerPage: "4",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Grid View2",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              // value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '12'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Quick Views",
            name: "Grid View2",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showDateTime: true,
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            ShowEnableTitle:false,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            itemsPerPage: "12",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 12,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Header",
          media: HeaderIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            logoUrl: "https://www.newsclick.in/sites/default/files/2022-11/narendra%20%20modi.jpg",
            isSticky: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            noOfHeaderItems: 9,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-toggle',
              label: 'Sticky Header',
              name: 'isSticky',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            },
          ]

        },

        {
          name: "Header Amp",
          media: HeaderIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ]

        },

        {
          name: "Hero Layout",
          traits: [

            {
              type: 'text',
              label: 'Title',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Time Stamp',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#fff',
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            showAuthorName: true,
            title: "Trending Today",
            name: "Hero Layout",
            showTimeStamp: true,
            showViewAll: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            viewAllUrl: "",
            showAdSlot: false,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 5,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Hero Layout2",
          traits: [

            {
              type: 'text',
              label: 'Title',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Time Stamp',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutSecondIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#fff',
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            showAuthorName: true,
            title: "Trending Today",
            name: "Hero Layout2",
            showTimeStamp: true,
            showViewAll: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            viewAllUrl: "",
            showAdSlot: false,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 9,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "List View",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Default Pagination', value: "page" },
                { label: 'Next Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '7'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            name: "List View",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showDateTime: true,
            type1: "page",
            background: '#fff',
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            showAuthorName: true,
            ShowEnableTitle:false,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            itemsPerPage: "7",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            adConfigurations: {},
            maxAdsAccordian: 1,
            adSlotLable: "Ad",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 7,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Page Not Found",
          traits: [
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },

        {
          name: "Page Gone",
          traits: [
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },

        {
          name: "Similar Stories",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: SimilarStoriesIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            name: "Similar Stories",
            version: "1000",
            showDateTime: true,
            background: '#fff',
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showAuthorName: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            isSimilarStories: true,

            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            adConfigurations: {},

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 7,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {

          name: "Slide Show",

            // scriptProps: [
            //   'imagecroptype' // The crucial addition for dropdown
            // ],

          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author Card',
            //   name: 'authorCard',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                 //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
          ],
          media: SlideShowIcon,
          attributes: {
            name: "Slide Show",
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Slide Show',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            authorCard: false,
            background: '#fff',
            imagecroptype: '4',
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "h",
                  preview: false,
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                preview: false,
                prime: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Static Page",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Title',
              name: 'showTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: StaticPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            background: '#fff',
            version: "1000",
            title: "Static Page",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTitle: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultStaticMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultStaticMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ],
                }
              }
            ]
          }
        },

        {
          name: "Video Show",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author Card',
            //   name: 'authorCard',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }

          ],
          media: VideoStoriesIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTags: true,
            showAuthorName: true,
            showTimeStamp: true,
            authorCard: false,
            showNewsAgency: true,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.VIDEO_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Web Stories",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            // {
            //   type: 'text',
            //   label: 'Items per-page',
            //   name: 'itemsPerPage',
            //   changeProp: 1,
            //   value: '5'
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: WebstoriesCard,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Quick Views",
            name: "Grid View",
            version: "1000",
            showDateTime: true,
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            // itemsPerPage: "5",
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 5,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Web Stories2",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'View All',
              name: 'showViewAll',
              changeProp: 1,
              options: [
                { id: "ddd", name: 'True', value: true },
                { id: 1, name: 'False', value: false }
              ],
              showViewURLField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'color',
              name: "background",
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '25'
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: WebstoriesCardList,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Web Stories",
            name: "Grid View",
            version: "1000",
            showDateTime: true,
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            ShowEnableTitle:false,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "25",
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 25,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        // {
        //   name: "GridView Other Two",
        //   traits: [
        //     {
        //       type: 'text',
        //       label: "Title",
        //       name: 'mainHeading',
        //       changeProp: 1
        //     },
        //     {
        //       type: 'text',
        //       label: "Title URL",
        //       name: 'mainHeadingHref',
        //       changeProp: 1
        //     },
        //     {
        //       type: 'color',
        //       label: "Title Text Color",
        //       name: 'mainHeadingColor',
        //       changeProp: 1
        //     },
        //     // {
        //     //   type: 'color',
        //     //   label: "BG Color",
        //     //   name: 'BgColor',
        //     //   changeProp: 1
        //     // },
        //     // {
        //     //   type: 'color',
        //     //   label: "Card BG Color",
        //     //   name: 'cardBGColor',
        //     //   changeProp: 1
        //     // },
        //     // {
        //     //   type: 'color',
        //     //   label: "Text Color",
        //     //   name: 'cardTextColor',
        //     //   changeProp: 1
        //     // },
        //     // {
        //     //   type: 'custom-select',
        //     //   label: 'Scroll Mode',
        //     //   name: 'scroll',
        //     //   changeProp: 1,
        //     //   options: [
        //     //     { label: 'Automatic', value: "automatic" },
        //     //     { label: 'Manual', value: "manual" },
        //     //   ]
        //     // },
        //     {
        //       type: 'custom-select',
        //       label: 'Select Type',
        //       name: 'type1',
        //       changeProp: 1,
        //       options: [
        //         { label: 'Pagination', value: "page" },
        //         { label: 'Next/Prev', value: "next" },
        //         { label: 'Load More', value: "load" },
        //         { label: 'No Pagination', value: "noPagination" }
        //       ],
        //       value: "page"
        //     },
        // {
        //   type: 'text',
        //   label: 'Items per-page',
        //   name: 'itemsPerPage',
        //   changeProp: 1,
        //   value: '10'
        // },
        //     {
        //       type: 'text',
        //       label: 'Scroll Count',
        //       name: 'scrollCount',
        //       changeProp: 1
        //     },
        //     {
        //       type: 'custom-toggle',
        //       label: 'Date',
        //       name: 'showDate',
        //       changeProp: 1,
        //       showDate:true,
        //       options: [
        //         { id: 3, name: 'True', value: true },
        //         { id: 4, name: 'False', value: false }
        //       ],
        //       isNotChecked: function () {
        //         const context = this;
        //         return !context.value;
        //       }
        //     },
        //     {
        //       type: 'custom-toggle',
        //       label: 'Ad Slot',
        //       name: 'showAdSlot',
        //       changeProp: 1,
        //       showAdSlotField: true,
        //       isNotChecked: function () {
        //         const context = this;
        //         return !context.value;
        //       }
        //     },
        //     DATA_MAPPING_TRAIT
        //   ],
        //   media: GridViewIconLess,
        //   attributes: {
        //     CONSTANTS: CONSTANTS,
        //     name: "Grid View",
        //     title: "Grid View",
        //     mainHeading: "Grid View",
        //     version: "1000",
        //     mainHeadingHref: "https://www.google.com",
        //     mainHeadingColor: "#000",
        //     BgColor: "#ffffff",
        //     cardBGColor: "#ffffff",
        //     cardTextColor:"#555555",
        //     scroll: "automatic",
        //     showDateTime: true,
        //     scrollCount: 1,
        //     ENV: CONSTANTS.ENV.M360_STAGING,
        //     showAdSlot: false,
        //     adNetwork: "google",
        //     headAdScript: "",
        //     bodyAdScript: "",
        //     bodyAdMobileScript: "",
        // itemsPerPage: "10",

        //     ENDPOINTS: [
        //       {
        //         name: "MAIN",
        //         LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
        //         STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
        //         isSSR: true,
        //         SSRDataObj: null,
        //         PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
        //         queryParams: {
        //           fv: 1000,
        //           hostId: defaultHostId,
        //           msid: defaultPriortyListMsid,
        //           apiType: "h",
        //           ct: 'all',
        //           st: 'date',
        //           so: 'dsc',
        //           cp: 1,
        //           pp: 3,
        //           cloneMapping: [
        //             {from: "defaultPriortyListMsid", to: "msid"},
        //             {from: "defaultHostId", to: "hostId"}
        //           ]
        //         }
        //       }
        //     ]
        //   }
        // },



        // {
        //   name: "PageNotFound Two ",
        //   traits: [
        //   ],
        //   media: ErrorPageIcon,
        //   attributes: {
        //     CONSTANTS: CONSTANTS.API_URL,
        //     title: "This is the Default title",
        //     version: "1000",
        //     showDateTime: true
        //   }
        // },

        {
          name: "Bread Crumbs Two Amp",
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "BreadCrumbs",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            seperator: ">>",
            categoryName: "",
            includeTitle: true,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" }
                  ]
                }
              }
            ]
          },
          media: BreadCrumbsIcon,
          traits: [
            {
              type: 'custom-select',
              label: 'Seperator',
              name: 'seperator',
              changeProp: 1,
              options: [
                { label: '>>', value: ">>" },
                { label: '>', value: ">" },
                { label: '/', value: "/" }
              ],
              value: ">>"
            },
            {
              type: 'text',
              name: 'categoryName',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Include Title',
              name: 'includeTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },


        // ----------------------------theme-Three-comoponents------------------------------------------------

                {
          name: "Bread Crumbs Three Amp",
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "BreadCrumbs",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            seperator: ">>",
            categoryName: "",
            includeTitle: true,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" }
                  ]
                }
              }
            ]
          },
          media: BreadCrumbsIcon,
          traits: [
            {
              type: 'custom-select',
              label: 'Seperator',
              name: 'seperator',
              changeProp: 1,
              options: [
                { label: '>>', value: ">>" },
                { label: '>', value: ">" },
                { label: '/', value: "/" }
              ],
              value: ">>"
            },
            {
              type: 'text',
              name: 'categoryName',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Include Title',
              name: 'includeTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },
        {
          name: "Ad Scripts Three",
          media: AddScriptIcon,
          traits: [
            // {
            //   type: 'custom-textarea',
            //   label: 'Header Script',
            //   name: 'headAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script',
            //   name: 'bodyAdScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-textarea',
            //   label: 'Body Script (Mobile)',
            //   name: 'bodyAdMobileScript',
            //   changeProp: 1,
            //   value: ''
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Ad Size',
            //   name: 'adSize',
            //   changeProp: 1,
            //   value: '300*100',
            //   options: [
            //     { label: '300*100', value: "300*100" },
            //     { label: '300*250', value: "300*250" },
            //     { label: '970*90', value: "970*90" },
            //   ]
            // },
            {
              type: 'belly-ad-accodian-trait',
              label: 'Ad Script',
              name: 'deviceType',
              changeProp: 1,
              value: '',

            }
          ],
          attributes: {
            title: "Ad Scripts Three",
            name: "Ad Scripts Three",
            version: "1000",
            adSize: "300*100",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            showAdSlot: true,
            maxAdsAccordian: 1,
            adSlotLable: "Ad",
            adConfigurations: {}
          }
        },

        {
          name: "Article Show Three",
          //   scriptProps: [
          //   'imagecroptype' // The crucial addition for dropdown
          // ],
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              options: [
                { id: 7, name: 'True', value: true },
                { id: 8, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 9, name: 'True', value: true },
                { id: 19, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
              {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                 //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adConfigurations: {},
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            authorCard: false,
            isImageTitle: true,
            imagecroptype: '4',

            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultArticleMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  links: 1,
                  count: 1,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Quiz Show",
          traits: [
            // {
            //   type: 'custom-toggle',
            //   label: 'Author',
            //   name: 'showAuthor',
            //   changeProp: 1,
            //   options: [
            //     { id: 1, name: 'True', value: true },
            //     { id: 2, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDateTime',
            //   changeProp: 1,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Quiz Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.QUIZ_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.QUIZ_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultQuizId,
                  hostId: defaultHostId,
                  fv: 1000,
                  links: 1,
                  count: 1,
                  cloneMapping: [
                    { from: "defaultQuizId", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Survey Show",
          traits: [
            // {
            //   type: 'custom-toggle',
            //   label: 'Author',
            //   name: 'showAuthor',
            //   changeProp: 1,
            //   options: [
            //     { id: 1, name: 'True', value: true },
            //     { id: 2, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDateTime',
            //   changeProp: 1,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Survey Show",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            //GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.SURVEY_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.SURVEY_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultSurveyId,
                  hostId: defaultHostId,
                  fv: 1000,
                  links: 1,
                  count: 1,
                  cloneMapping: [
                    { from: "defaultSurveyId", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Author Show Three",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Department',
              name: 'showDepartment',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcon',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: AuthorShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Author Show Three",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showSocialIcon: true,
            showDepartment: true,
            background: '#fff',
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.AUTHOR_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.AUTHOR_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultAuthorID,
                  fv: 1000,
                  hostId: defaultHostId,
                  cloneMapping: [
                    { from: "defaultAuthorID", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "BreadCrumbs Three",
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "BreadCrumbs",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            seperator: ">>",
            categoryName: "",
            TextColor: "#4D90CE",
            includeTitle: true,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          media: BreadCrumbsIcon,
          traits: [
            {
              type: 'custom-select',
              label: 'Seperator',
              name: 'seperator',
              changeProp: 1,
              options: [
                { label: '>>', value: ">>" },
                { label: '>', value: ">" },
                { label: '/', value: "/" }
              ],
              value: ">>"
            },
            {
              type: 'text',
              name: 'categoryName',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Include Title',
              name: 'includeTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },
        {
          name: "Breaking News Ticker",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Heading BG Color",
              name: 'HeadingBGColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Heading Text Color",
              name: 'HeadingTextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'BGColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            }
          ],
          media: BreakingNewsIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: false,
            CONSTANTS: CONSTANTS,
            name: "Breaking News Ticker",
            title: "Breaking News Ticker",
            mainHeading: "Breaking News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            HeadingBGColor: "#0A66C2",
            HeadingTextColor: "#fff",
            TextColor: "#fff",
            BgColor: "#000000",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_TICKER_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_TICKER_API,
                isSSR: false,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  tenantId: tenantId,
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Experts",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            // {
            //   type: 'text',
            //   label: 'Items per-page',
            //   name: 'itemsPerPage',
            //   changeProp: 1,
            //   value: '10'
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Experts",
            title: "Experts",
            mainHeading: "Experts",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#fff",
            cardTextColor: "#fff",
            // cardBgColor: "#f1f1f1",
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            // itemsPerPage: "10",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Faq List",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            name: "Faq List",
            title: "Faq List",
            mainHeading: "Faq List",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardTextColor: "#000",
            // cardBgColor: "#f1f1f1",
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                // primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }

            ]
          }
        },


        {
          name: "Footer Three",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title Text",
              name: 'TitleText',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'About Site',
              name: 'showAbout',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcons',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'copyRightText',
              name: 'showSocialIcons',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Static Pages',
              name: 'showStaticPages',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: FooterIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#151515',
            BgColor: '#151515',
            TextColor: '#fff',
            TitleText: "Recent Post/ Events",
            showAbout: true,
            showSocialIcons: true,
            copyRightText: "",
            footerLogo: "",
            title: "Footer",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            noOfHeaderItems: 5,

            ENDPOINTS: [
              {
                name: "HEADER_DATA",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "FOOTER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.FOOTER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.FOOTER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 2,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Four Links",
          traits: [
            {
              type: 'color',
              label: "BG Color",
              name: 'BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: FooterIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#3D3D3D',
            BgColor: '#3D3D3D',
            TextColor: '#fff',
            showAbout: true,
            showSocialIcons: true,
            copyRightText: "",
            footerLogo: "",
            title: "Four Links",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "GridView Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            // {
            //   type: 'text',
            //   label: 'Items per-page',
            //   name: 'itemsPerPage',
            //   changeProp: 1,
            //   value: '12'
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIconLess,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "GridView Three",
            title: "Grid View",
            mainHeading: "Grid View",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            BgColor: "#ffffff",
            cardBGColor: "#ffffff",
            cardTextColor: "#000",
            scroll: "automatic",
            showDate: true,
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            // itemsPerPage: "12",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 12,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Header Three",
          media: HeaderIcon,
          attributes: {
            // CONSTANTS: CONSTANTS.API_URL,
            CONSTANTS: CONSTANTS,
            version: "1000",
            background: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            logoUrl: "https://www.newsclick.in/sites/default/files/2022-11/narendra%20%20modi.jpg",
            isSticky: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            mainHeadingColor: "#000",
            L1BgColor: "#ffffff",
            L2BgColor: "#f1f1f1",
            L1TextColor: "#555555",
            L2TextColor: "#555555",
            HamburgerBgColor: "#ffffff",
            HamburgerTextColor: "#555555",
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            noOfHeaderItems: 6,
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "BREAD_CRUMBS_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAD_CRUMBS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAD_CRUMBS_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultArticleMsid,
                  apiType: 'nav',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'color',
              label: "L1 BG Color",
              name: 'L1BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L1 Text Color",
              name: 'L1TextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L2 BG Color",
              name: 'L2BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "L2 Text Color",
              name: 'L2TextColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Hamburger BG Color",
              name: 'HamburgerBgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Hamburger Text Color",
              name: 'HamburgerTextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            {
              type: 'custom-toggle',
              label: 'Sticky Header',
              name: 'isSticky',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ]
        },

        {
          name: "HeroLayout with Header",
          media: HeaderIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#fff',
            CTAText: 'Discover More',
            CTABgColor: '#f29d38',
            CTATextColor: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            logoUrl: "https://www.newsclick.in/sites/default/files/2022-11/narendra%20%20modi.jpg",
            ENV: CONSTANTS.ENV.M360_STAGING,
            noOfHeaderItems: 6,

            ENDPOINTS: [
              {
                name: "HEADER_WRAPPER",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 5,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'color',
              label: "CTA Bg Color",
              name: 'CTABgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "CTA Text Color",
              name: 'CTATextColor',
              changeProp: 1
            },
            {
              type: 'text',
              label: "CTA Text",
              name: 'CTAText',
              changeProp: 1
            },
            {
              type: 'text',
              label: 'Number of Items',
              name: 'noOfHeaderItems',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ]
        },
        {
          name: "HeroLayout Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'textColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showdate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            name: "Hero layout Three",
            title: "Hero layout Three",
            mainHeading: "Hero layout Three",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            cardTextColor: "#000",
            textColor: "#000000",
            showAuthor: true,
            showDate: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "HeroLayout Hr Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'True', value: true }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: HeroLayoutSecondIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Hero layout Hr Three",
            title: "Hero layout Hr Three",
            mainHeading: "Hero layout Hr Three",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            // cardBGColor: "pink",
            cardBGColor: "transparent",
            cardActiveColor: "#ffffff",
            showAuthor: true,
            showDate: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Home Faq",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'bgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Strip BG Color",
              name: 'stripbgColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            name: "Faq List",
            title: "Faq List",
            mainHeading: "Frequently Asked Questions",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardTextColor: "#000",
            bgColor: "#F9F8F8",
            stripbgColor: '#f1f1f1',
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                // primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }

            ]
          }
        },


        {
          name: "Home Grid View Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'text',
              label: "View All",
              name: 'viewAllText',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Tag Color",
              name: 'tagColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Tag Text Color",
              name: 'tagTextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            // CONSTANTS: CONSTANTS,
            CONSTANTS: CONSTANTS.API_URL,
            name: "Top News",
            title: "Top News",
            mainHeading: "Top News",
            viewAllText: "View All",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            BgColor: "#ffffff",
            cardBGColor: "#ffffff",
            cardTextColor: "#000",
            tagColor: "#f29d38",
            tagTextColor: '#ffffff',
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthor: true,
            showDate: true,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 6,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Home Photo Gallery",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDate',
            //   changeProp: 1,
            //   showDate: true,
            //   options: [
            //     { id: 1, name: 'True', value: true },
            //     { id: 2, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author',
            //   name: 'showAuthor',
            //   changeProp: 1,
            //   showAuthor: true,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },

            // {
            //   type: 'custom-select',
            //   label: 'Select Type',
            //   name: 'type1',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Pagination', value: "page" },
            //     { label: 'Next/Prev', value: "next" },
            //     { label: 'Load More', value: "load" },
            //     { label: 'No Pagination', value: "noPagination" }
            //   ],
            //   value: "page"
            // },
            // {
            //   type: 'text',
            //   label: 'Items per-page',
            //   name: 'itemsPerPage',
            //   changeProp: 1,
            //   value: '10'
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot2',
            //   name: 'showAdSlot2',
            //   changeProp: 1,
            //   showAdSlotField2: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Home Gallery",
            name: "Home Gallery",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            mainHeadingColor: '#000000',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthor: true,
            showDate: true,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            showAdSlot2: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adNetwork2: "google",
            headAdScript2: "",
            bodyAdScript2: "",
            bodyAdMobileScript2: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            // itemsPerPage: "10",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 3,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Home Web Stories",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              showAuthor: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: WebstoriesCard,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Web Stories",
            name: "Web Stories",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthor: true,
            showDate: true,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            showAdSlot2: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adNetwork2: "google",
            headAdScript2: "",
            bodyAdScript2: "",
            bodyAdMobileScript2: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 5,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Quick View Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },

            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDate',
            //   changeProp: 1,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author',
            //   name: 'showAuthor',
            //   changeProp: 1,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: BreakingNewsIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            // CONSTANTS: CONSTANTS,
            CONSTANTS: CONSTANTS.API_URL,
            name: "Quick View",
            title: "Quick View",
            mainHeading: "Quick View",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardBGColor: "#fff",
            cardActiveColor: "#fff",
            showDateField: true,
            showAuthorField: true,
            showDate: true,
            showAuthor: true,
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "List View Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '10'
            },
            // {
            //   type: 'color',
            //   label: "Card Color",
            //   name: 'cardColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "BG Color",
            //   name: 'cardBgColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'color',
            //   label: "Card Text Color",
            //   name: 'cardTextColor',
            //   changeProp: 1
            // },
            // {
            //   type: 'custom-select',
            //   label: 'Scroll Mode',
            //   name: 'scroll',
            //   changeProp: 1,
            //   options: [
            //     { label: 'Automatic', value: "automatic" },
            //     { label: 'Manual', value: "manual" },
            //   ]
            // },
            // {
            //   type: 'text',
            //   label: 'Scroll Count',
            //   name: 'scrollCount',
            //   changeProp: 1
            // },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            name: "List View Three",
            title: "List View",
            mainHeading: "List View",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardTextColor: "#000",
            // cardBgColor: "#f1f1f1",
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            ShowEnableTitle:false,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "10",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "LISTING_SH_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "sh",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "MediaList Three",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '20'
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Media List",
            name: "MediaList Three",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showDateTime: true,
            mainHeadingColor: '#000',
            cardTextColor: '#000',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthorName: true,
            showViewAll: false,
            viewAllUrl: "",
            showAdSlot: false,
            ShowEnableTitle:false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            itemsPerPage: "20",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 20,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "OtherList View",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '10'
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              showDate: true,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "OtherList View",
            title: "OtherList View",
            mainHeading: "OtherList View",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#fff",
            cardTextColor: "#fff",
            // cardBgColor: "#f1f1f1",
            cardColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            showAuthor: true,
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "10",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "PageNotFound Three",
          traits: [
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },
        {
          name: "PageGone Three",
          traits: [
          ],
          media: ErrorPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "This is the Default title",
            version: "1000",
            showDateTime: true
          }
        },
        {
          name: "PhotoList Three",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Date',
            //   name: 'showDate',
            //   changeProp: 1,
            //   showDate: true,
            //   options: [
            //     { id: 1, name: 'True', value: true },
            //     { id: 2, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Author',
            //   name: 'showAuthor',
            //   changeProp: 1,
            //   showAuthor: true,
            //   options: [
            //     { id: 3, name: 'True', value: true },
            //     { id: 4, name: 'False', value: false }
            //   ],
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'View All',
            //   name: 'showViewAll',
            //   changeProp: 1,
            //   options: [
            //     { id: "ddd", name: 'True', value: true },
            //     { id: 1, name: 'False', value: false }
            //   ],
            //   showViewURLField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'custom-toggle',
            //   label: 'Viewport',
            //   name: 'showViewport',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            // {
            //   type: 'text',
            //   label: 'Images In Viewport',
            //   name: 'imagesInViewport',
            //   changeProp: 1,
            //   value: 'all'
            // },

            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '12'
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot2',
              name: 'showAdSlot2',
              changeProp: 1,
              showAdSlotField2: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            title: "Photo List Three",
            name: "PhotoList Three",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            background: '#fff',
            stylesheets: [],
            type1: "page",
            scrollMode: 0,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            showAuthor: true,
            showDate: true,
            showViewAll: false,
            viewAllUrl: "",
            ShowEnableTitle:false,
            showAdSlot: false,
            showAdSlot2: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            adNetwork2: "google",
            headAdScript2: "",
            bodyAdScript2: "",
            bodyAdMobileScript2: "",
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            itemsPerPage: "12",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 12,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                prime: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultListingMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Podcast Three",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }

          ],
          media: VideoStoriesIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTags: true,
            showAuthorName: true,
            showTimeStamp: true,
            showNewsAgency: true,
            authorCard: false,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.VIDEO_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "RhsHome Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Home Related News",
            title: "Home Related News",
            mainHeading: "Home Related News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardContentColor: "#000",
            cardBGColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthorName: false,
            showHeading: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 6,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "RhsHome Other Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },

            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,

              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Heading',
              name: 'showHeading',
              changeProp: 1,
              showHeading: false,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: ListViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS.API_URL,
            name: "Related News",
            title: "Related News",
            mainHeading: "Related News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            cardContentColor: "#000",
            cardBGColor: "transparent",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            showAuthorName: true,
            showHeading: true,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 7,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {

          name: "Slide Show Three",
          //  scriptProps: [
          //   'imagecroptype' // The crucial addition for dropdown
          // ],
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
             {
              type: 'custom-select',
              label: 'Hero Image Resize Type',
              name: 'imagecroptype',
              changeProp: 1,
              options: [
                 //  { label: 'Select Type', value: "75" },
                { label: 'Central Cropping', value: "4" },
                { label: 'White Border', value: "71" },
                { label: 'Black Border', value: "72" },
                { label: 'Most Prominent Color', value: "73" },
                { label: 'Most Prominent Color (single)', value: "74" },
                { label: 'Blurred Background', value: "75" },
                { label: 'Face-Aware Cropping', value: "8" },
              ],
              value: "4"
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: SlideShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Slide Show Three',
            name: 'Slide Show Three',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            background: '#fff',
            showAdSlot: false,
            authorCard: false,
            imagecroptype: '4',
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                SSRDataObj: null,
                preview: false,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                prime: true,
                loading: "LAZY",
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },




        {
          name: "Static Page Three",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Title',
              name: 'showTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: StaticPageIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            background: '#fff',
            version: "1000",
            title: "Static Page Two",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTitle: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultStaticMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultStaticMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ],
                }
              }
            ]
          }
        },

        {
          name: "Breaking News Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'BGColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Content Color",
              name: 'cardContentColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Card BG Color",
              name: 'cardBGColor',
              changeProp: 1
            },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: BreakingNewsIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Trending News",
            title: "Trending News",
            mainHeading: "Trending News",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            // cardBGColor: "pink",
            cardBGColor: "#fff",
            cardActiveColor: "#fff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Video Show Three",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthorName',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showTimeStamp',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }

          ],
          media: VideoStoriesIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showTags: true,
            showAuthorName: true,
            showTimeStamp: true,
            showNewsAgency: true,
            authorCard: false,
            onClick: () => {
              var settingBtn = document.querySelectorAll('[title="Component Properties"]');
              settingBtn[0].click();
            },
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.VIDEO_SHOW_API,
                primary: true,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 4,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "WebStories Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'cardBGColor',
              changeProp: 1
            },
            // {
            //   type: 'color',
            //   label: "Card Color",
            //   name: 'cardActiveColor',
            //   changeProp: 1
            // },
            {
              type: 'custom-select',
              label: 'Scroll Mode',
              name: 'scroll',
              changeProp: 1,
              options: [
                { label: 'Automatic', value: "automatic" },
                { label: 'Manual', value: "manual" },
              ]
            },
            {
              type: 'text',
              label: 'Scroll Count',
              name: 'scrollCount',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Ad Slot',
            //   name: 'showAdSlot',
            //   changeProp: 1,
            //   showAdSlotField: true,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            DATA_MAPPING_TRAIT
          ],
          media: CarouselCardIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Web Stories",
            title: "Web Stories",
            mainHeading: "Web Stories",
            version: "1000",
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            showDate: true,
            ShowEnableTitle:false,
            // cardBGColor: "pink",
            cardBGColor: "#EFEFEF",
            cardActiveColor: "#ffffff",
            scroll: "automatic",
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 10,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "WebStoriesList Three",
          traits: [
            {
              type: 'text',
              label: "Title",
              name: 'mainHeading',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title URL",
              name: 'mainHeadingHref',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Title Text Color",
              name: 'mainHeadingColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDate',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Enable Title',
              name: 'ShowEnableTitle',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-select',
              label: 'Select Type',
              name: 'type1',
              changeProp: 1,
              options: [
                { label: 'Pagination', value: "page" },
                { label: 'Next/Prev', value: "next" },
                { label: 'Load More', value: "load" },
                { label: 'No Pagination', value: "noPagination" }
              ],
              value: "page"
            },
            {
              type: 'text',
              label: 'Items per-page',
              name: 'itemsPerPage',
              changeProp: 1,
              value: '12'
            },
            {
              type: 'custom-toggle',
              label: 'Open In New Tab',
              name: 'anchorLinksValue',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            DATA_MAPPING_TRAIT
          ],
          media: GridViewIcon,
          attributes: {
            STATIC_MAPPING_TRAIT: true,
            CONSTANTS: CONSTANTS,
            name: "Web Stories List",
            title: "Web Stories List",
            mainHeading: "Web Stories List",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            mainHeadingHref: "https://www.google.com",
            mainHeadingColor: "#000",
            BgColor: "#ffffff",
            cardBgColor: "transparent",
            cardTextColor: "#fff",
            scroll: "automatic",
            showDate: true,
            ShowEnableTitle:false,
            scrollCount: 1,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showAdSlot: false,
            adNetwork: "google",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            itemsPerPage: "12",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                isListView: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "h",
                  ct: 'webstory',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 12,
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                loading: "LAZY",
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultPriortyListMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultPriortyListMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },


        // -------------------------End---theme-Three-comoponents------------------------------------------------
        // ----------------------------theme-Three-amp-comoponents------------------------------------------------
        {
          name: "Article Show Three Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },

            // {
            //   type: 'custom-toggle',
            //   label: 'Author Card',
            //   name: 'authorCard',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Tags',
              name: 'showTags',
              changeProp: 1,
              options: [
                { id: 7, name: 'True', value: true },
                { id: 8, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 9, name: 'True', value: true },
                { id: 19, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Image Title',
              name: 'isImageTitle',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ],
          media: ArticleShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: "Article Show",
            name: "Article Show Three Amp",
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showAdSlot: false,
            showTags: true,
            background: '#fff',
            showNewsAgency: true,
            ENV: CONSTANTS.ENV.M360_STAGING,
            showViewport: true,
            imagesInViewport: "all",
            adNetwork: "google",
            adSize: "1",
            headAdScript: "",
            bodyAdScript: "",
            bodyAdMobileScript: "",
            // authorCard: false,
            isImageTitle: true,
            // GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",
            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.ARTICLE_SHOW_API,
                primary: true,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  msid: defaultArticleMsid,
                  hostId: defaultHostId,
                  fv: 1000,
                  cloneMapping: [
                    { from: "defaultArticleMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Footer Three Amp",
          traits: [
            {
              type: 'text',
              name: 'title',
              changeProp: 1
            },
            {
              type: 'text',
              label: "Title Text",
              name: 'TitleText',
              changeProp: 1
            },
            {
              type: 'color',
              label: "BG Color",
              name: 'BgColor',
              changeProp: 1
            },
            {
              type: 'color',
              label: "Text Color",
              name: 'TextColor',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'About Site',
              name: 'showAbout',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Social Icons',
              name: 'showSocialIcons',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'copyRightText',
              name: 'showSocialIcons',
              changeProp: 1
            },
            {
              type: 'custom-toggle',
              label: 'Static Pages',
              name: 'showStaticPages',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // },
            DATA_MAPPING_TRAIT
          ],
          media: FooterIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#151515',
            BgColor: '#151515',
            TextColor: '#fff',
            TitleText: "Recent Post/ Events",
            showAbout: true,
            showSocialIcons: true,
            copyRightText: "",
            footerLogo: "",
            title: "Footer",
            isSticky: true,
            showStaticPages: true,
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "HEADER_DATA",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },
              {
                name: "FOOTER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.FOOTER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.FOOTER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.BREAKING_NEWS_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.BREAKING_NEWS_API,
                isSSR: true,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultListingMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  pp: 2,
                  cloneMapping: [
                    { from: "defaultListingMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        {
          name: "Header Three Amp",
          media: HeaderIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            version: "1000",
            background: '#fff',
            stylesheets: [],
            title: "Header",
            showSearch: true,
            stylesheets: [],
            ENV: CONSTANTS.ENV.M360_STAGING,

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_DATA_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_DATA_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  websiteId: retrievedWebsiteId,
                  clientId: retrievedClientId,
                  cloneMapping: [
                    { from: "retrievedWebsiteId", to: "websiteId" },
                    { from: "retrievedClientId", to: "clientId" }
                  ]
                }
              },

              {
                name: "HEADER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.HEADER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.HEADER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              },

              {
                name: "TOGGLER_MENU_API",
                LIVE_API_URL: RENDERING_ENDPOINTS.TOGGLER_MENU_API,
                STAG_API_URL: PAGE_BUILDER_ENDPOINTS.TOGGLER_MENU_API,
                isSSR: true,
                SSRDataObj: null,
                isNotListing: true,
                queryParams: {
                  hostId: userHostId,
                  cloneMapping: [
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          },
          traits: [
            {
              type: 'custom-toggle',
              label: 'Search',
              name: 'showSearch',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
            // {
            //   type: 'custom-toggle',
            //   label: 'Open In New Tab',
            //   name: 'anchorLinksValue',
            //   changeProp: 1,
            //   isNotChecked: function () {
            //     const context = this;
            //     return !context.value;
            //   }
            // }
          ]

        },
        {
          name: "Photo Show Three Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            },
            {
              type: 'custom-toggle',
              label: 'Image Credit',
              name: 'showImageCredits',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            }
          ],
          media: SlideShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Photo Show Three Amp',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            showAdSlot: false,
            authorCard: false,
            background: '#fff',
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            showViewport: true,
            imagesInViewport: "all",

            adConfigurations: {},
            maxAdsAccordian: 8,
            adSlotLable: "Belly",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_API,
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              },
              {
                name: "SEO_URL",
                LIVE_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                STAG_API_URL: RENDERING_ENDPOINTS.LISTING_DETAIL_API,
                primary: true,
                prime: true,
                loading: "LAZY",
                isSSR: true,
                preview: false,
                SSRDataObj: null,
                PB_ENDPOINTS: PAGE_BUILDER_ENDPOINTS,
                queryParams: {
                  fv: 1000,
                  hostId: userHostId,
                  msid: defaultSlideshowMsid,
                  apiType: "d",
                  cloneMapping: [
                    { from: "defaultSlideshowMsid", to: "msid" },
                    { from: "userHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },
        {
          name: "Video Show Three Amp",
          traits: [
            {
              type: 'custom-toggle',
              label: 'Author',
              name: 'showAuthor',
              changeProp: 1,
              options: [
                { id: 1, name: 'True', value: true },
                { id: 2, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Author Card',
              name: 'authorCard',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Date',
              name: 'showDateTime',
              changeProp: 1,
              options: [
                { id: 3, name: 'True', value: true },
                { id: 4, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'News Agency',
              name: 'showNewsAgency',
              changeProp: 1,
              options: [
                { id: 5, name: 'True', value: true },
                { id: 6, name: 'False', value: false }
              ],
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Ad Slot',
              name: 'showAdSlot',
              changeProp: 1,
              showAdSlotField: true,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'custom-toggle',
              label: 'Viewport',
              name: 'showViewport',
              changeProp: 1,
              isNotChecked: function () {
                const context = this;
                return !context.value;
              }
            },
            {
              type: 'text',
              label: 'Images In Viewport',
              name: 'imagesInViewport',
              changeProp: 1,
              value: 'all'
            }
          ],
          media: SlideShowIcon,
          attributes: {
            CONSTANTS: CONSTANTS.API_URL,
            title: 'Video Show Three Amp',
            version: "1000",
            EXPORTED_DATA: {
              SEO_DATA: null
            },
            showAuthor: true,
            showDateTime: true,
            showNewsAgency: true,
            showAdSlot: false,
            background: '#fff',
            authorCard: false,
            mappings: {
              type: "pathquery",
              requestKey: 'msid',
              value: 'object.attributes.ENDPOINTS.forEach(o => { o.queryParams.msid = msid });'
            },
            ENV: CONSTANTS.ENV.M360_STAGING,
            GLOBAL_DATA_COMPONENT: { init: true, dateTimeFormat: 'MMM DD, YYYY, HH:MM TZ', publishedOrUpdated: 'published' },
            showViewport: true,
            imagesInViewport: "all",

            ENDPOINTS: [
              {
                name: "MAIN",
                LIVE_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                STAG_API_URL: RENDERING_ENDPOINTS.VIDEO_SHOW_API,
                isSSR: true,
                SSRDataObj: null,
                queryParams: {
                  fv: 1000,
                  hostId: defaultHostId,
                  msid: defaultVideoMsid,
                  apiType: "h",
                  ct: 'all',
                  st: 'date',
                  so: 'dsc',
                  cp: 1,
                  cloneMapping: [
                    { from: "defaultVideoMsid", to: "msid" },
                    { from: "defaultHostId", to: "hostId" }
                  ]
                }
              }
            ]
          }
        },

        // -------------------------End---theme-Three-amp-comoponents------------------------------------------------


      ]
    }
    resolve(componentJson);
  })

}

export default createComponentJson;
